const GREEN_AWARD_FORMS = {
    '42493d2f77a84bf9a0f465451df71ff9': {
        title: [
            {lang: "ru", name: "Форма заявки"},
            {lang: "en", name: "Форма заявки"},
        ],
        fields: [
            {
                type: 'text',
                name: 'team',
                required: true,
                label: [
                    {lang: "ru", name: "Организация"},
                    {lang: "en", name: "Организация"},
                ],
                placeholder: [
                    {lang: "ru", name: "Полное наименование организации"},
                    {lang: "en", name: "Полное наименование организации"},
                ]
            },
            {
                type: 'text',
                name: 'contactName',
                required: true,
                label: [
                    {lang: "ru", name: "Контактное лицо"},
                    {lang: "en", name: "Контактное лицо"},
                ],
                placeholder: [
                    {lang: "ru", name: "ФИО представителя организации"},
                    {lang: "en", name: "ФИО представителя организации"},
                ]
            },
            {
                type: 'text',
                name: 'participantPhone',
                required: true,
                label: [
                    {lang: "ru", name: "Контактный телефон"},
                    {lang: "en", name: "Контактный телефон"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите контактный номер телефона"},
                    {lang: "en", name: "Укажите контактный номер телефона"},
                ],
                hint: [
                    {lang: "ru", name: "Формат телефона: +7-777-777-77-77"},
                    {lang: "en", name: "Формат телефона: +7-777-777-77-77"},
                ],
            },
            {
                type: 'text',
                name: 'participantEmail',
                required: true,
                label: [
                    {lang: "ru", name: "E-mail"},
                    {lang: "en", name: "E-mail"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите E-mail"},
                    {lang: "en", name: "Укажите E-mail"},
                ]
            },
            {
                type: 'text',
                name: 'projectTitle',
                required: true,
                max: 75,
                label: [
                    {lang: "ru", name: "Название проекта"},
                    {lang: "en", name: "Название проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите название проекта"},
                    {lang: "en", name: "Укажите название проекта"},
                ],
                hint: [
                    {lang: "ru", name: "Максимум 75 символов включая пробелы"},
                    {lang: "en", name: "Максимум 75 символов включая пробелы"},
                ],
            },
            {
                type: 'text',
                name: 'geography',
                required: true,
                label: [
                    {lang: "ru", name: "География"},
                    {lang: "en", name: "География"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите где присутствует или реализован проект"},
                    {lang: "en", name: "Укажите где присутствует или реализован проект"},
                ]
            },
            {
                type: 'text',
                name: 'reach',
                required: true,
                label: [
                    {lang: "ru", name: "Охват"},
                    {lang: "en", name: "Охват"},
                ],
                placeholder: [
                    {lang: "ru", name: "Какое количество людей было затронуто проектом"},
                    {lang: "en", name: "Какое количество людей было затронуто проектом"},
                ]
            },
            {
                type: 'text',
                name: 'partners',
                label: [
                    {lang: "ru", name: "Партнеры проекта"},
                    {lang: "en", name: "Партнеры проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите партнеров Вашего проекта, если они есть"},
                    {lang: "en", name: "Укажите партнеров Вашего проекта, если они есть"},
                ]
            },
            {
                type: 'text',
                name: 'goal',
                required: true,
                label: [
                    {lang: "ru", name: "Цель"},
                    {lang: "en", name: "Цель"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите цель Вашего проекта"},
                    {lang: "en", name: "Укажите цель Вашего проекта"},
                ]
            },
            {
                type: 'text',
                name: 'description',
                required: true,
                multiline: true,
                max: 500,
                label: [
                    {lang: "ru", name: "Описание"},
                    {lang: "en", name: "Описание"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите Ваш проект"},
                    {lang: "en", name: "Опишите Ваш проект"},
                ],
            },
            {
                type: 'text',
                name: 'plans',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Планы проекта"},
                    {lang: "en", name: "Планы проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите планы на Ваш проект"},
                    {lang: "en", name: "Укажите планы на Ваш проект"},
                ],
                max: 300,
            },
            {
                type: 'text',
                name: 'result',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Результат"},
                    {lang: "en", name: "Результат"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите результат Вашего проекта"},
                    {lang: "en", name: "Опишите результат Вашего проекта"},
                ],
                max: 800,
            },
            {
                type: 'text',
                name: 'links',
                required: true,
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылка на соц. сети, сайт"},
                    {lang: "en", name: "Ссылка на соц. сети, сайт"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
             {
                type: 'text',
                name: 'mediaLinks',
                multipleValues: true,
                label: [
                    { lang: "ru", name: "Ссылки на СМИ о проекте" },
                    { lang: "en", name: "Ссылки на СМИ о проекте" },
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'demoLink',
                label: [
                    {lang: "ru", name: "Ссылка на презентацию"},
                    {lang: "en", name: "Ссылка на презентацию"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'imageArray',
                name: 'projectFilesIds',
                required: true,
                label: [
                    {lang: "ru", name: "Фото"},
                    {lang: "en", name: "Фото"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
                onlyJpgFormat:true
            },
            {
                type: 'dropdown',
                name: 'sources',
                freeTypeIndex: 3,
                label: [
                    {lang: "ru", name: "Откуда Вы узнали о «Зеленой премии»?"},
                    {lang: "en", name: "Откуда Вы узнали о «Зеленой премии»?"},
                ],
                placeholder: [
                    {lang: "ru", name: "Выберите значение"},
                    {lang: "en", name: "Выберите значение"},
                ],
                options: [{
                        label: [
                            {lang: "ru", name: "СМИ"},
                            {lang: "en", name: "СМИ"},
                        ],
                        value: 'СМИ',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Интернет"},
                            {lang: "en", name: "Интернет"},
                        ],
                        value: 'Интернет',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Друзья"},
                            {lang: "en", name: "Друзья"},
                        ],
                        value: 'Друзья',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Другое"},
                            {lang: "en", name: "Другое"},
                        ],
                        value: 'Другое',
                    }
                ],
                min: 2,
            },
            {
                type: 'cover',
                name: 'titleImage',
                required: true,
                label: [
                    {lang: "ru", name: "Обложка проекта"},
                    {lang: "en", name: "Обложка проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
            },
            // {
            //     type: 'agreement',
            //     name: 'agreement',
            //     required: true,
            //     label: [
            //         {lang: "ru", name: "Соглашение"},
            //         {lang: "en", name: "Agreement"},
            //     ],
            // },
        ]
    },
    //___________________________________________________________________________
    '8b7c88b557dd4a5b90dad959b205104e': {
        title: [
            {lang: "ru", name: "Форма заявки"},
            {lang: "en", name: "Форма заявки"},
        ],
        fields: [
            {
                type: 'text',
                name: 'university',
                required: true,
                label: [
                    {lang: "ru", name: "Образовательное учреждение"},
                    {lang: "en", name: "Образовательное учреждение"},
                ],
                placeholder: [
                    {lang: "ru", name: "Полное наименование организации"},
                    {lang: "en", name: "Полное наименование организации"},
                ]
            },
            {
                type: 'text',
                name: 'projectAuthor',
                required: true,
                label: [
                    {lang: "ru", name: "Автор проекта"},
                    {lang: "en", name: "Автор проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "ФИО"},
                    {lang: "en", name: "ФИО"},
                ],
                hint: [
                    {lang: "ru", name: "Можно добавить соавтора проекта"},
                    {lang: "en", name: "You can add a co-author to the project"},
                ],
            },
            {
                type: 'text',
                name: 'participantPhone',
                required: true,
                label: [
                    {lang: "ru", name: "Контактный телефон"},
                    {lang: "en", name: "Контактный телефон"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите контактный номер телефона"},
                    {lang: "en", name: "Укажите контактный номер телефона"},
                ],
                hint: [
                    {lang: "ru", name: "Формат телефона: +7-777-777-77-77"},
                    {lang: "en", name: "Формат телефона: +7-777-777-77-77"},
                ],
            },
            {
                type: 'text',
                name: 'participantEmail',
                required: true,
                label: [
                    {lang: "ru", name: "E-mail"},
                    {lang: "en", name: "E-mail"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите E-mail"},
                    {lang: "en", name: "Укажите E-mail"},
                ]
            },
            {
                type: 'text',
                name: 'projectTitle',
                required: true,
                max: 75,
                label: [
                    {lang: "ru", name: "Название проекта"},
                    {lang: "en", name: "Название проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите название проекта"},
                    {lang: "en", name: "Укажите название проекта"},
                ],
                hint: [
                    {lang: "ru", name: "Максимум 75 символов включая пробелы"},
                    {lang: "en", name: "Максимум 75 символов включая пробелы"},
                ],
            },
            {
                type: 'text',
                name: 'geography',
                required: true,
                label: [
                    {lang: "ru", name: "География"},
                    {lang: "en", name: "География"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите где присутствует или реализован проект"},
                    {lang: "en", name: "Укажите где присутствует или реализован проект"},
                ]
            },
            {
                type: 'text',
                name: 'reach',
                required: true,
                label: [
                    {lang: "ru", name: "Охват"},
                    {lang: "en", name: "Охват"},
                ],
                placeholder: [
                    {lang: "ru", name: "Какое количество людей было затронуто проектом"},
                    {lang: "en", name: "Какое количество людей было затронуто проектом"},
                ]
            },
            {
                type: 'text',
                name: 'partners',
                label: [
                    {lang: "ru", name: "Партнеры проекта"},
                    {lang: "en", name: "Партнеры проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите партнеров Вашего проекта, если они есть"},
                    {lang: "en", name: "Укажите партнеров Вашего проекта, если они есть"},
                ]
            },
            {
                type: 'text',
                name: 'goal',
                required: true,
                label: [
                    {lang: "ru", name: "Цель"},
                    {lang: "en", name: "Цель"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите цель Вашего проекта"},
                    {lang: "en", name: "Укажите цель Вашего проекта"},
                ]
            },
            {
                type: 'text',
                name: 'description',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Описание"},
                    {lang: "en", name: "Описание"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите Ваш проект"},
                    {lang: "en", name: "Опишите Ваш проект"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'plans',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Планы проекта"},
                    {lang: "en", name: "Планы проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите планы на Ваш проект"},
                    {lang: "en", name: "Укажите планы на Ваш проект"},
                ],
                max: 300,
            },
            {
                type: 'text',
                name: 'result',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Результат"},
                    {lang: "en", name: "Результат"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите результат Вашего проекта"},
                    {lang: "en", name: "Опишите результат Вашего проекта"},
                ],
                max: 800,
            },
            {
                type: 'text',
                name: 'links',
                required: true,
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылка на соц. сети, сайт"},
                    {lang: "en", name: "Ссылка на соц. сети, сайт"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'mediaLinks',
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылки на СМИ о проекте"},
                    {lang: "en", name: "Ссылки на СМИ о проекте"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'demoLink',
                label: [
                    {lang: "ru", name: "Ссылка на презентацию"},
                    {lang: "en", name: "Ссылка на презентацию"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'imageArray',
                name: 'projectFilesIds',
                required: true,
                label: [
                    {lang: "ru", name: "Фото"},
                    {lang: "en", name: "Фото"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
                onlyJpgFormat:true
            },
            {
                type: 'dropdown',
                name: 'sources',
                freeTypeIndex: 3,
                label: [
                    {lang: "ru", name: "Откуда Вы узнали о «Зеленой премии»?"},
                    {lang: "en", name: "Откуда Вы узнали о «Зеленой премии»?"},
                ],
                placeholder: [
                    {lang: "ru", name: "Выберите значение"},
                    {lang: "en", name: "Выберите значение"},
                ],
                options: [{
                        label: [
                            {lang: "ru", name: "СМИ"},
                            {lang: "en", name: "СМИ"},
                        ],
                        value: 'СМИ',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Интернет"},
                            {lang: "en", name: "Интернет"},
                        ],
                        value: 'Интернет',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Друзья"},
                            {lang: "en", name: "Друзья"},
                        ],
                        value: 'Друзья',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Другое"},
                            {lang: "en", name: "Другое"},
                        ],
                        value: 'Другое',
                    }
                ],
                min: 2,
            },
            {
                type: 'cover',
                name: 'titleImage',
                required: true,
                label: [
                    {lang: "ru", name: "Обложка проекта"},
                    {lang: "en", name: "Обложка проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
            },
            // {
            //     type: 'agreement',
            //     name: 'agreement',
            //     required: true,
            //     label: [
            //         {lang: "ru", name: "Соглашение"},
            //         {lang: "en", name: "Agreement"},
            //     ],
            // },
        ],
        
    },
    //___________________________________________________________________________
    '8edf1a5a40e94e489fc79a7de29e864c': {
        title: [
            {lang: "ru", name: "Форма заявки"},
            {lang: "en", name: "Форма заявки"},
        ],
        fields: [
            {
                type: 'text',
                name: 'team',
                required: true,
                label: [
                    {lang: "ru", name: "Организация"},
                    {lang: "en", name: "Организация"},
                ],
                placeholder: [
                    {lang: "ru", name: "Полное наименование организации"},
                    {lang: "en", name: "Полное наименование организации"},
                ]
            },
            {
                type: 'text',
                name: 'contactName',
                required: true,
                label: [
                    {lang: "ru", name: "Контактное лицо"},
                    {lang: "en", name: "Контактное лицо"},
                ],
                placeholder: [
                    {lang: "ru", name: "ФИО представителя организации"},
                    {lang: "en", name: "ФИО представителя организации"},
                ]
            },
            {
                type: 'text',
                name: 'participantPhone',
                required: true,
                label: [
                    {lang: "ru", name: "Контактный телефон"},
                    {lang: "en", name: "Контактный телефон"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите контактный номер телефона"},
                    {lang: "en", name: "Укажите контактный номер телефона"},
                ],
                hint: [
                    {lang: "ru", name: "Формат телефона: +7-777-777-77-77"},
                    {lang: "en", name: "Формат телефона: +7-777-777-77-77"},
                ],
            },
            {
                type: 'text',
                name: 'participantEmail',
                required: true,
                label: [
                    {lang: "ru", name: "E-mail"},
                    {lang: "en", name: "E-mail"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите E-mail"},
                    {lang: "en", name: "Укажите E-mail"},
                ]
            },
            {
                type: 'text',
                name: 'projectTitle',
                required: true,
                max: 75,
                label: [
                    {lang: "ru", name: "Название проекта"},
                    {lang: "en", name: "Название проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите название проекта"},
                    {lang: "en", name: "Укажите название проекта"},
                ],
                hint: [
                    {lang: "ru", name: "Максимум 75 символов включая пробелы"},
                    {lang: "en", name: "Максимум 75 символов включая пробелы"},
                ],
            },
            {
                type: 'text',
                name: 'geography',
                required: true,
                label: [
                    {lang: "ru", name: "География"},
                    {lang: "en", name: "География"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите где присутствует или реализован проект"},
                    {lang: "en", name: "Укажите где присутствует или реализован проект"},
                ]
            },
            {
                type: 'text',
                name: 'reach',
                required: true,
                label: [
                    {lang: "ru", name: "Охват"},
                    {lang: "en", name: "Охват"},
                ],
                placeholder: [
                    {lang: "ru", name: "Какое количество людей было затронуто проектом"},
                    {lang: "en", name: "Какое количество людей было затронуто проектом"},
                ]
            },
            {
                type: 'text',
                name: 'partners',
                label: [
                    {lang: "ru", name: "Партнеры проекта"},
                    {lang: "en", name: "Партнеры проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите партнеров Вашего проекта, если они есть"},
                    {lang: "en", name: "Укажите партнеров Вашего проекта, если они есть"},
                ]
            },
            {
                type: 'text',
                name: 'goal',
                required: true,
                label: [
                    {lang: "ru", name: "Цель"},
                    {lang: "en", name: "Цель"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите цель Вашего проекта"},
                    {lang: "en", name: "Укажите цель Вашего проекта"},
                ]
            },
            {
                type: 'text',
                name: 'description',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Описание"},
                    {lang: "en", name: "Описание"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите Ваш проект"},
                    {lang: "en", name: "Опишите Ваш проект"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'plans',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Планы проекта"},
                    {lang: "en", name: "Планы проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите планы на Ваш проект"},
                    {lang: "en", name: "Укажите планы на Ваш проект"},
                ],
                max: 300,
            },
            {
                type: 'text',
                name: 'result',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Результат"},
                    {lang: "en", name: "Результат"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите результат Вашего проекта"},
                    {lang: "en", name: "Опишите результат Вашего проекта"},
                ],
                max: 800,
            },
            {
                type: 'text',
                name: 'links',
                required: true,
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылка на соц. сети, сайт"},
                    {lang: "en", name: "Ссылка на соц. сети, сайт"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'mediaLinks',
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылки на СМИ о проекте"},
                    {lang: "en", name: "Ссылки на СМИ о проекте"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'demoLink',
                label: [
                    {lang: "ru", name: "Ссылка на презентацию"},
                    {lang: "en", name: "Ссылка на презентацию"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'imageArray',
                name: 'projectFilesIds',
                required: true,
                label: [
                    {lang: "ru", name: "Фото"},
                    {lang: "en", name: "Фото"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
                onlyJpgFormat:true
            },
            {
                type: 'dropdown',
                name: 'sources',
                freeTypeIndex: 3,
                label: [
                    {lang: "ru", name: "Откуда Вы узнали о «Зеленой премии»?"},
                    {lang: "en", name: "Откуда Вы узнали о «Зеленой премии»?"},
                ],
                placeholder: [
                    {lang: "ru", name: "Выберите значение"},
                    {lang: "en", name: "Выберите значение"},
                ],
                options: [{
                        label: [
                            {lang: "ru", name: "СМИ"},
                            {lang: "en", name: "СМИ"},
                        ],
                        value: 'СМИ',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Интернет"},
                            {lang: "en", name: "Интернет"},
                        ],
                        value: 'Интернет',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Друзья"},
                            {lang: "en", name: "Друзья"},
                        ],
                        value: 'Друзья',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Другое"},
                            {lang: "en", name: "Другое"},
                        ],
                        value: 'Другое',
                    }
                ],
                min: 2,
            },
            {
                type: 'cover',
                name: 'titleImage',
                required: true,
                label: [
                    {lang: "ru", name: "Обложка проекта"},
                    {lang: "en", name: "Обложка проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
            },
            // {
            //     type: 'agreement',
            //     name: 'agreement',
            //     required: true,
            //     label: [
            //         {lang: "ru", name: "Соглашение"},
            //         {lang: "en", name: "Agreement"},
            //     ],
            // },
        ]
    },
    //___________________________________________________________________________
    '8461cb11b0724f6790280fd1c159137f': {
        title: [
            {lang: "ru", name: "Форма заявки"},
            {lang: "en", name: "Форма заявки"},
        ],
        fields: [
            {
                type: 'text',
                name: 'university',
                required: true,
                label: [
                    {lang: "ru", name: "Образовательное учреждение"},
                    {lang: "en", name: "Образовательное учреждение"},
                ],
                placeholder: [
                    {lang: "ru", name: "Полное наименование организации"},
                    {lang: "en", name: "Полное наименование организации"},
                ]
            },
            {
                type: 'text',
                name: 'projectAuthor',
                required: true,
                label: [
                    {lang: "ru", name: "Автор проекта"},
                    {lang: "en", name: "Автор проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "ФИО"},
                    {lang: "en", name: "ФИО"},
                ],
                 hint: [
                    {lang: "ru", name: "Можно добавить соавтора проекта"},
                    {lang: "en", name: "You can add a co-author to the project"},
                ],
            },
            {
                type: 'text',
                name: 'participantPhone',
                required: true,
                label: [
                    {lang: "ru", name: "Контактный телефон"},
                    {lang: "en", name: "Контактный телефон"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите контактный номер телефона"},
                    {lang: "en", name: "Укажите контактный номер телефона"},
                ],
                hint: [
                    {lang: "ru", name: "Формат телефона: +7-777-777-77-77"},
                    {lang: "en", name: "Формат телефона: +7-777-777-77-77"},
                ],
            },
            {
                type: 'text',
                name: 'participantEmail',
                required: true,
                label: [
                    {lang: "ru", name: "E-mail"},
                    {lang: "en", name: "E-mail"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите E-mail"},
                    {lang: "en", name: "Укажите E-mail"},
                ]
            },
            {
                type: 'text',
                name: 'projectTitle',
                required: true,
                max: 75,
                label: [
                    {lang: "ru", name: "Название проекта"},
                    {lang: "en", name: "Название проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите название проекта"},
                    {lang: "en", name: "Укажите название проекта"},
                ],
                hint: [
                    {lang: "ru", name: "Максимум 75 символов включая пробелы"},
                    {lang: "en", name: "Максимум 75 символов включая пробелы"},
                ],
            },
            {
                type: 'text',
                name: 'geography',
                required: true,
                label: [
                    {lang: "ru", name: "География"},
                    {lang: "en", name: "География"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите где присутствует или реализован проект"},
                    {lang: "en", name: "Укажите где присутствует или реализован проект"},
                ]
            },
            {
                type: 'text',
                name: 'reach',
                required: true,
                label: [
                    {lang: "ru", name: "Охват"},
                    {lang: "en", name: "Охват"},
                ],
                placeholder: [
                    {lang: "ru", name: "Какое количество людей было затронуто проектом"},
                    {lang: "en", name: "Какое количество людей было затронуто проектом"},
                ]
            },
            {
                type: 'text',
                name: 'partners',
                label: [
                    {lang: "ru", name: "Партнеры проекта"},
                    {lang: "en", name: "Партнеры проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите партнеров Вашего проекта, если они есть"},
                    {lang: "en", name: "Укажите партнеров Вашего проекта, если они есть"},
                ]
            },
            {
                type: 'text',
                name: 'goal',
                required: true,
                label: [
                    {lang: "ru", name: "Цель"},
                    {lang: "en", name: "Цель"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите цель Вашего проекта"},
                    {lang: "en", name: "Укажите цель Вашего проекта"},
                ]
            },
            {
                type: 'text',
                name: 'description',
                required: true,
                multiline: true,
                label: [
                    {lang: "ru", name: "Описание"},
                    {lang: "en", name: "Описание"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите Ваш проект"},
                    {lang: "en", name: "Опишите Ваш проект"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'plans',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Планы проекта"},
                    {lang: "en", name: "Планы проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите планы на Ваш проект"},
                    {lang: "en", name: "Укажите планы на Ваш проект"},
                ],
                max: 300,
            },
            {
                type: 'text',
                name: 'result',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Результат"},
                    {lang: "en", name: "Результат"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите результат Вашего проекта"},
                    {lang: "en", name: "Опишите результат Вашего проекта"},
                ],
                max: 800,
            },
            {
                type: 'text',
                name: 'links',
                required: true,
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылка на соц. сети, сайт"},
                    {lang: "en", name: "Ссылка на соц. сети, сайт"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'mediaLinks',
                multipleValues: true,
                required: true,
                label: [
                    {lang: "ru", name: "Ссылки на СМИ о проекте"},
                    {lang: "en", name: "Ссылки на СМИ о проекте"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'demoLink',
                label: [
                    {lang: "ru", name: "Ссылка на презентацию"},
                    {lang: "en", name: "Ссылка на презентацию"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'imageArray',
                name: 'projectFilesIds',
                required: true,
                label: [
                    {lang: "ru", name: "Фото"},
                    {lang: "en", name: "Фото"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
                onlyJpgFormat:true
            },
            {
                type: 'dropdown',
                name: 'sources',
                freeTypeIndex: 3,
                label: [
                    {lang: "ru", name: "Откуда Вы узнали о «Зеленой премии»?"},
                    {lang: "en", name: "Откуда Вы узнали о «Зеленой премии»?"},
                ],
                placeholder: [
                    {lang: "ru", name: "Выберите значение"},
                    {lang: "en", name: "Выберите значение"},
                ],
                options: [{
                        label: [
                            {lang: "ru", name: "СМИ"},
                            {lang: "en", name: "СМИ"},
                        ],
                        value: 'СМИ',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Интернет"},
                            {lang: "en", name: "Интернет"},
                        ],
                        value: 'Интернет',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Друзья"},
                            {lang: "en", name: "Друзья"},
                        ],
                        value: 'Друзья',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Другое"},
                            {lang: "en", name: "Другое"},
                        ],
                        value: 'Другое',
                    }
                ],
                min: 2,
            },
            {
                type: 'cover',
                name: 'titleImage',
                required: true,
                label: [
                    {lang: "ru", name: "Обложка проекта"},
                    {lang: "en", name: "Обложка проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
            },
            // {
            //     type: 'agreement',
            //     name: 'agreement',
            //     required: true,
            //     label: [
            //         {lang: "ru", name: "Соглашение"},
            //         {lang: "en", name: "Agreement"},
            //     ],
            // },
        ]
    },
    //___________________________________________________________________________
    'c9b7f61ee5e349f495dfe237dd3109df': {
        title: [
            {lang: "ru", name: "Форма заявки"},
            {lang: "en", name: "Форма заявки"},
        ],
        fields: [
            {
                type: 'text',
                name: 'team',
                required: true,
                label: [
                    {lang: "ru", name: "Организация"},
                    {lang: "en", name: "Организация"},
                ],
                placeholder: [
                    {lang: "ru", name: "Полное наименование организации"},
                    {lang: "en", name: "Полное наименование организации"},
                ]
            },
            {
                type: 'text',
                name: 'projectAuthor',
                required: true,
                label: [
                    {lang: "ru", name: "Автор проекта"},
                    {lang: "en", name: "Автор проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "ФИО"},
                    {lang: "en", name: "ФИО"},
                ],
                 hint: [
                    {lang: "ru", name: "Можно добавить соавтора проекта"},
                    {lang: "en", name: "You can add a co-author to the project"},
                ],
            },
            {
                type: 'text',
                name: 'participantPhone',
                required: true,
                label: [
                    {lang: "ru", name: "Контактный телефон"},
                    {lang: "en", name: "Контактный телефон"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите контактный номер телефона"},
                    {lang: "en", name: "Укажите контактный номер телефона"},
                ],
                hint: [
                    {lang: "ru", name: "Формат телефона: +7-777-777-77-77"},
                    {lang: "en", name: "Формат телефона: +7-777-777-77-77"},
                ],
            },
            {
                type: 'text',
                name: 'participantEmail',
                required: true,
                label: [
                    {lang: "ru", name: "E-mail"},
                    {lang: "en", name: "E-mail"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите E-mail"},
                    {lang: "en", name: "Укажите E-mail"},
                ]
            },
            {
                type: 'text',
                name: 'projectTitle',
                required: true,
                max: 75,
                label: [
                    {lang: "ru", name: "Название проекта"},
                    {lang: "en", name: "Название проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите название проекта"},
                    {lang: "en", name: "Укажите название проекта"},
                ],
                hint: [
                    {lang: "ru", name: "Максимум 75 символов включая пробелы"},
                    {lang: "en", name: "Максимум 75 символов включая пробелы"},
                ],
            },
            {
                type: 'text',
                name: 'geography',
                required: true,
                label: [
                    {lang: "ru", name: "География"},
                    {lang: "en", name: "География"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите где присутствует или реализован проект"},
                    {lang: "en", name: "Укажите где присутствует или реализован проект"},
                ]
            },
            {
                type: 'text',
                name: 'reach',
                required: true,
                label: [
                    {lang: "ru", name: "Охват"},
                    {lang: "en", name: "Охват"},
                ],
                placeholder: [
                    {lang: "ru", name: "Какое количество людей было затронуто проектом"},
                    {lang: "en", name: "Какое количество людей было затронуто проектом"},
                ]
            },
            {
                type: 'text',
                name: 'partners',
                label: [
                    {lang: "ru", name: "Партнеры проекта"},
                    {lang: "en", name: "Партнеры проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите партнеров Вашего проекта, если они есть"},
                    {lang: "en", name: "Укажите партнеров Вашего проекта, если они есть"},
                ]
            },
            {
                type: 'text',
                name: 'description',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Описание"},
                    {lang: "en", name: "Описание"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите Ваш проект"},
                    {lang: "en", name: "Опишите Ваш проект"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'plans',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Планы проекта"},
                    {lang: "en", name: "Планы проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите планы на Ваш проект"},
                    {lang: "en", name: "Укажите планы на Ваш проект"},
                ],
                max: 400,
            },
            {
                type: 'text',
                name: 'result',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Результат"},
                    {lang: "en", name: "Результат"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите результат Вашего проекта"},
                    {lang: "en", name: "Опишите результат Вашего проекта"},
                ],
                max: 800,
            },
            {
                type: 'text',
                name: 'links',
                required: true,
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылка на соц. сети, сайт"},
                    {lang: "en", name: "Ссылка на соц. сети, сайт"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'mediaLinks',
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылки на СМИ о проекте"},
                    {lang: "en", name: "Ссылки на СМИ о проекте"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'demoLink',
                label: [
                    {lang: "ru", name: "Ссылка на презентацию"},
                    {lang: "en", name: "Ссылка на презентацию"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'imageArray',
                name: 'projectFilesIds',
                required: true,
                label: [
                    {lang: "ru", name: "Фото"},
                    {lang: "en", name: "Фото"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
                onlyJpgFormat:true
            },
            {
                type: 'dropdown',
                name: 'sources',
                freeTypeIndex: 3,
                label: [
                    {lang: "ru", name: "Откуда Вы узнали о «Зеленой премии»?"},
                    {lang: "en", name: "Откуда Вы узнали о «Зеленой премии»?"},
                ],
                placeholder: [
                    {lang: "ru", name: "Выберите значение"},
                    {lang: "en", name: "Выберите значение"},
                ],
                options: [{
                        label: [
                            {lang: "ru", name: "СМИ"},
                            {lang: "en", name: "СМИ"},
                        ],
                        value: 'СМИ',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Интернет"},
                            {lang: "en", name: "Интернет"},
                        ],
                        value: 'Интернет',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Друзья"},
                            {lang: "en", name: "Друзья"},
                        ],
                        value: 'Друзья',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Другое"},
                            {lang: "en", name: "Другое"},
                        ],
                        value: 'Другое',
                    }
                ],
                min: 2,
            },
            {
                type: 'cover',
                name: 'titleImage',
                required: true,
                label: [
                    {lang: "ru", name: "Обложка проекта"},
                    {lang: "en", name: "Обложка проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
            },
            // {
            //     type: 'agreement',
            //     name: 'agreement',
            //     required: true,
            //     label: [
            //         {lang: "ru", name: "Соглашение"},
            //         {lang: "en", name: "Agreement"},
            //     ],
            // },
        ]
    },
    //___________________________________________________________________________
    '9b26f859c5734929bdbc3f21a6570a10': {
        title: [
            { lang: "ru", name: "Форма заявки" },
            { lang: "en", name: "Форма заявки" },
        ],
        fields: [
            {
                type: 'text',
                name: 'team',
                required: true,
                label: [
                    { lang: "ru", name: "Организация" },
                    { lang: "en", name: "Организация" },
                ],
                placeholder: [
                    { lang: "ru", name: "Полное наименование организации" },
                    { lang: "en", name: "Полное наименование организации" },
                ],
            },
            {
                type: 'text',
                name: 'projectTitle',
                required: true,
                max: 75,
                label: [
                    { lang: "ru", name: "Название проекта" },
                    { lang: "en", name: "Название проекта" },
                ],
                placeholder: [
                    { lang: "ru", name: "Укажите название проекта" },
                    { lang: "en", name: "Укажите название проекта" },
                ],
                hint: [
                    {lang: "ru", name: "Максимум 75 символов включая пробелы"},
                    {lang: "en", name: "Максимум 75 символов включая пробелы"},
                ],
            },
            {
                type: 'text',
                name: 'projectAuthor',
                required: true,
                label: [
                    { lang: "ru", name: "Автор проекта" },
                    { lang: "en", name: "Автор проекта" },
                ],
                placeholder: [
                    { lang: "ru", name: "ФИО представителей" },
                    { lang: "en", name: "ФИО представителей" },
                ],
                 hint: [
                    {lang: "ru", name: "Можно добавить соавтора проекта"},
                    {lang: "en", name: "You can add a co-author to the project"},
                ],
            },
            {
                type: 'text',
                name: 'participantPhone',
                required: true,
                label: [
                    { lang: "ru", name: "Контактный телефон" },
                    { lang: "en", name: "Контактный телефон" },
                ],
                placeholder: [
                    { lang: "ru", name: "Укажите контактный номер телефона" },
                    { lang: "en", name: "Укажите контактный номер телефона" },
                ],
                hint: [
                    {lang: "ru", name: "Формат телефона: +7-777-777-77-77"},
                    {lang: "en", name: "Формат телефона: +7-777-777-77-77"},
                ],
            },
            {
                type: 'text',
                name: 'participantEmail',
                required: true,
                label: [
                    { lang: "ru", name: "E-mail" },
                    { lang: "en", name: "E-mail" },
                ],
                placeholder: [
                    { lang: "ru", name: "Укажите E-mail" },
                    { lang: "en", name: "Укажите E-mail" },
                ],
            },
            {
                type: 'text',
                name: 'geography',
                required: true,
                label: [
                    { lang: "ru", name: "География" },
                    { lang: "en", name: "География" },
                ],
                placeholder: [
                    { lang: "ru", name: "Укажите где присутствует или реализован проект" },
                    { lang: "en", name: "Укажите где присутствует или реализован проект" },
                ],
            },
            {
                type: 'text',
                name: 'reach',
                required: true,
                label: [
                    { lang: "ru", name: "Охват" },
                    { lang: "en", name: "Охват" },
                ],
                placeholder: [
                    { lang: "ru", name: "Какое количество людей было затронуто проектом" },
                    { lang: "en", name: "Какое количество людей было затронуто проектом" },
                ],
            },
            {
                type: 'text',
                name: 'partners',
                label: [
                    { lang: "ru", name: "Партнеры проекта" },
                    { lang: "en", name: "Партнеры проекта" },
                ],
                placeholder: [
                    { lang: "ru", name: "Укажите партнеров Вашего проекта, если они есть" },
                    { lang: "en", name: "Укажите партнеров Вашего проекта, если они есть" },
                ],
            },
            {
                type: 'text',
                name: 'description',
                multiline: true,
                required: true,
                label: [
                    { lang: "ru", name: "Описание" },
                    { lang: "en", name: "Описание" },
                ],
                placeholder: [
                    { lang: "ru", name: "Опишите Ваш проект" },
                    { lang: "en", name: "Опишите Ваш проект" },
                ],
            },
            {
                type: 'text',
                name: 'plans',
                multiline: true,
                required: true,
                label: [
                    { lang: "ru", name: "Планы проекта" },
                    { lang: "en", name: "Планы проекта" },
                ],
                placeholder: [
                    { lang: "ru", name: "Укажите планы на Ваш проект" },
                    { lang: "en", name: "Укажите планы на Ваш проект" },
                ],
            },
            {
                type: 'text',
                name: 'result_2',
                multiline: true,
                required: true,
                label: [
                    { lang: "ru", name: "Результаты" },
                    { lang: "en", name: "Результаты" },
                ],
                placeholder: [
                    { lang: "ru", name: "Опишите результат Вашего проекта" },
                    { lang: "en", name: "Опишите результат Вашего проекта" },
                ],
                hint: [
                    { lang: "ru", name: "объем сбыта производимой продукции/оказываемых услуг" },
                    { lang: "en", name: "объем сбыта производимой продукции/оказываемых услуг" },
                ],
                max: 400
            },
            {
                type: 'text',
                name: 'indicators',
                multiline: true,
                required: true,
                label: [
                    { lang: "ru", name: "Финансовые показатели деятельности бизнеса" },
                    { lang: "en", name: "Финансовые показатели деятельности бизнеса" },
                ],
                placeholder: [
                    { lang: "ru", name: "Опишите финансовые показатели Вашего проекта" },
                    { lang: "en", name: "Опишите финансовые показатели Вашего проекта" },
                ],
                max: 400
            },
            {
                type: 'text',
                name: 'links',
                required: true,
                multipleValues: true,
                label: [
                    { lang: "ru", name: "Ссылка на соц. сети, сайт" },
                    { lang: "en", name: "Ссылка на соц. сети, сайт" },
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'mediaLinks',
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылки на СМИ о проекте"},
                    {lang: "en", name: "Ссылки на СМИ о проекте"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'demoLink',
                label: [
                    { lang: "ru", name: "Ссылка на презентацию" },
                    { lang: "en", name: "Ссылка на презентацию" },
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'imageArray',
                name: 'projectFilesIds',
                required: true,
                label: [
                    {lang: "ru", name: "Фото"},
                    {lang: "en", name: "Фото"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
                onlyJpgFormat:true,
            },
            {
                type: 'dropdown',
                name: 'sources',
                freeTypeIndex: 3,
                label: [
                    {lang: "ru", name: "Откуда Вы узнали о «Зеленой премии»?"},
                    {lang: "en", name: "Откуда Вы узнали о «Зеленой премии»?"},
                ],
                placeholder: [
                    {lang: "ru", name: "Выберите значение"},
                    {lang: "en", name: "Выберите значение"},
                ],
                options: [{
                        label: [
                            {lang: "ru", name: "СМИ"},
                            {lang: "en", name: "СМИ"},
                        ],
                        value: 'СМИ',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Интернет"},
                            {lang: "en", name: "Интернет"},
                        ],
                        value: 'Интернет',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Друзья"},
                            {lang: "en", name: "Друзья"},
                        ],
                        value: 'Друзья',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Другое"},
                            {lang: "en", name: "Другое"},
                        ],
                        value: 'Другое',
                    }
                ],
                min: 2,
            },
            {
                type: 'cover',
                name: 'titleImage',
                required: true,
                label: [
                    {lang: "ru", name: "Обложка проекта"},
                    {lang: "en", name: "Обложка проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
            },
            // {
            //     type: 'agreement',
            //     name: 'agreement',
            //     required: true,
            //     label: [
            //         {lang: "ru", name: "Соглашение"},
            //         {lang: "en", name: "Agreement"},
            //     ],
            // },
        ]
    },
    //___________________________________________________________________________
    '8b120248cd494750814b42b361f0acd9': {
        title: [
            {lang: "ru", name: "Форма заявки"},
            {lang: "en", name: "Форма заявки"},
        ],
        fields: [
            {
                type: 'text',
                name: 'team',
                required: true,
                label: [
                    {lang: "ru", name: "Организация "},
                    {lang: "en", name: "Организация "},
                ],
                placeholder: [
                    {lang: "ru", name: "Полное наименование организации"},
                    {lang: "en", name: "Полное наименование организации"},
                ]
            },
            {
                type: 'text',
                name: 'projectAuthor',
                required: true,
                label: [
                    {lang: "ru", name: "Автор проекта"},
                    {lang: "en", name: "Автор проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "ФИО представителя"},
                    {lang: "en", name: "ФИО представителя"},
                ],
                 hint: [
                    {lang: "ru", name: "Можно добавить соавтора проекта"},
                    {lang: "en", name: "You can add a co-author to the project"},
                ],
            },
            {
                type: 'text',
                name: 'participantPhone',
                required: true,
                label: [
                    {lang: "ru", name: "Контактный телефон"},
                    {lang: "en", name: "Контактный телефон"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите контактный номер телефона"},
                    {lang: "en", name: "Укажите контактный номер телефона"},
                ],
                hint: [
                    {lang: "ru", name: "Формат телефона: +7-777-777-77-77"},
                    {lang: "en", name: "Формат телефона: +7-777-777-77-77"},
                ],
            },
            {
                type: 'text',
                name: 'participantEmail',
                required: true,
                label: [
                    {lang: "ru", name: "E-mail"},
                    {lang: "en", name: "E-mail"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите E-mail"},
                    {lang: "en", name: "Укажите E-mail"},
                ]
            },
            {
                type: 'text',
                name: 'projectTitle',
                required: true,
                max: 75,
                label: [
                    {lang: "ru", name: "Название проекта"},
                    {lang: "en", name: "Название проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите название проекта"},
                    {lang: "en", name: "Укажите название проекта"},
                ],
                hint: [
                    {lang: "ru", name: "Максимум 75 символов включая пробелы"},
                    {lang: "en", name: "Максимум 75 символов включая пробелы"},
                ],
            },
            {
                type: 'text',
                name: 'geography',
                required: true,
                label: [
                    {lang: "ru", name: "География"},
                    {lang: "en", name: "География"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите где присутствует или реализован проект"},
                    {lang: "en", name: "Укажите где присутствует или реализован проект"},
                ]
            },
            {
                type: 'text',
                name: 'partners',
                label: [
                    {lang: "ru", name: "Партнеры проекта"},
                    {lang: "en", name: "Партнеры проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите партнеров Вашего проекта, если они есть"},
                    {lang: "en", name: "Укажите партнеров Вашего проекта, если они есть"},
                ]
            },
            {
                type: 'text',
                name: 'description',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Описание"},
                    {lang: "en", name: "Описание"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите Ваш проект"},
                    {lang: "en", name: "Опишите Ваш проект"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'plans',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Планы проекта"},
                    {lang: "en", name: "Планы проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите планы на Ваш проект"},
                    {lang: "en", name: "Укажите планы на Ваш проект"},
                ],
                max: 300,
            },
            {
                type: 'text',
                name: 'result',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Результат"},
                    {lang: "en", name: "Результат"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите результат Вашего проекта"},
                    {lang: "en", name: "Опишите результат Вашего проекта"},
                ],
                max: 800,
            },
            {
                type: 'text',
                name: 'links',
                required: true,
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылка на соц. сети, сайт"},
                    {lang: "en", name: "Ссылка на соц. сети, сайт"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'mediaLinks',
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылки на СМИ о проекте"},
                    {lang: "en", name: "Ссылки на СМИ о проекте"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'demoLink',
                label: [
                    {lang: "ru", name: "Ссылка на презентацию"},
                    {lang: "en", name: "Ссылка на презентацию"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'imageArray',
                name: 'projectFilesIds',
                required: true,
                label: [
                    {lang: "ru", name: "Фото"},
                    {lang: "en", name: "Фото"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
                onlyJpgFormat:true
            },
            {
                type: 'dropdown',
                name: 'sources',
                freeTypeIndex: 3,
                label: [
                    {lang: "ru", name: "Откуда Вы узнали о «Зеленой премии»?"},
                    {lang: "en", name: "Откуда Вы узнали о «Зеленой премии»?"},
                ],
                placeholder: [
                    {lang: "ru", name: "Выберите значение"},
                    {lang: "en", name: "Выберите значение"},
                ],
                options: [{
                        label: [
                            {lang: "ru", name: "СМИ"},
                            {lang: "en", name: "СМИ"},
                        ],
                        value: 'СМИ',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Интернет"},
                            {lang: "en", name: "Интернет"},
                        ],
                        value: 'Интернет',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Друзья"},
                            {lang: "en", name: "Друзья"},
                        ],
                        value: 'Друзья',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Другое"},
                            {lang: "en", name: "Другое"},
                        ],
                        value: 'Другое',
                    }
                ],
                min: 2,
            },
            {
                type: 'cover',
                name: 'titleImage',
                required: true,
                label: [
                    {lang: "ru", name: "Обложка проекта"},
                    {lang: "en", name: "Обложка проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
            },
            // {
            //     type: 'agreement',
            //     name: 'agreement',
            //     required: true,
            //     label: [
            //         {lang: "ru", name: "Соглашение"},
            //         {lang: "en", name: "Agreement"},
            //     ],
            // },
        ]
    },
    //___________________________________________________________________________
    '348fda0aace24dc28cd5c5ffe77cf230': {
        title: [
            {lang: "ru", name: "Форма заявки"},
            {lang: "en", name: "Форма заявки"},
        ],
        fields: [
            {
                type: 'text',
                name: 'projectAuthor',
                required: true,
                label: [
                    {lang: "ru", name: "Автор проекта"},
                    {lang: "en", name: "Автор проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "ФИО"},
                    {lang: "en", name: "ФИО"},
                ],
                 hint: [
                    {lang: "ru", name: "Можно добавить соавтора проекта"},
                    {lang: "en", name: "You can add a co-author to the project"},
                ],
            },
            {
                type: 'text',
                name: 'participantPhone',
                required: true,
                label: [
                    {lang: "ru", name: "Контактный телефон"},
                    {lang: "en", name: "Контактный телефон"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите контактный номер телефона"},
                    {lang: "en", name: "Укажите контактный номер телефона"},
                ],
                hint: [
                    {lang: "ru", name: "Формат телефона: +7-777-777-77-77"},
                    {lang: "en", name: "Формат телефона: +7-777-777-77-77"},
                ],
            },
            {
                type: 'text',
                name: 'participantEmail',
                required: true,
                label: [
                    {lang: "ru", name: "E-mail"},
                    {lang: "en", name: "E-mail"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите E-mail"},
                    {lang: "en", name: "Укажите E-mail"},
                ]
            },
            {
                type: 'date',
                name: 'birthDate',
                required: true,
                label: [
                    {lang: "ru", name: "Дата рождения"},
                    {lang: "en", name: "Дата рождения"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите Вашу дату рождения"},
                    {lang: "en", name: "Укажите Вашу дату рождения"},
                ]
            },
            {
                type: 'text',
                name: 'work',
                required: true,
                label: [
                    {lang: "ru", name: "Место работы и должность"},
                    {lang: "en", name: "Место работы и должность"},
                ],
                placeholder: [
                    {lang: "ru", name: "Полное наименование организации"},
                    {lang: "en", name: "Полное наименование организации"},
                ]
            },
            {
                type: 'text',
                name: 'geography',
                required: true,
                label: [
                    {lang: "ru", name: "География"},
                    {lang: "en", name: "География"},
                ],
                placeholder: [
                    {lang: "ru", name: "Основной регион вашей деятельности"},
                    {lang: "en", name: "Основной регион вашей деятельности"},
                ]
            },
            {
                type: 'text',
                name: 'reach',
                required: true,
                label: [
                    {lang: "ru", name: "Охват"},
                    {lang: "en", name: "Охват"},
                ],
                placeholder: [
                    {lang: "ru", name: "Какое количество людей вы охватываете"},
                    {lang: "en", name: "Какое количество людей вы охватываете"},
                ]
            },
            {
                type: 'text',
                name: 'description',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Краткое описание Вашей деятельности"},
                    {lang: "en", name: "Краткое описание Вашей деятельности"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите Ваш проект"},
                    {lang: "en", name: "Опишите Ваш проект"},
                ],
                max: 200,
            },
            {
                type: 'text',
                name: 'description_2',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Подробное описание Вашей деятельности"},
                    {lang: "en", name: "Подробное описание Вашей деятельности"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите Вашу деятельность с подробным перечислением наиболее знаковых проектов"},
                    {lang: "en", name: "Опишите Вашу деятельность с подробным перечислением наиболее знаковых проектов"},
                ],
                max: 700,
            },
            {
                type: 'text',
                name: 'plans',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Ваши планы в экологической деятельности на 2025 год"},
                    {lang: "en", name: "Ваши планы в экологической деятельности на 2025 год"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите Ваши планы на общественную экологическую деятельность, какие проекты/ мероприятия/ акции планируете реализовать/ разработать"},
                    {lang: "en", name: "Опишите Ваши планы на общественную экологическую деятельность, какие проекты/ мероприятия/ акции планируете реализовать/ разработать"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'result',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Достижения"},
                    {lang: "en", name: "Достижения"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите Ваши достижения (награды, благодарственные письма, участие в конкурсах)"},
                    {lang: "en", name: "Укажите Ваши достижения (награды, благодарственные письма, участие в конкурсах)"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'links',
                required: true,
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылка на соц. сети, сайт"},
                    {lang: "en", name: "Ссылка на соц. сети, сайт"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'mediaLinks',
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылки на СМИ о проекте"},
                    {lang: "en", name: "Ссылки на СМИ о проекте"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'demoLink',
                label: [
                    {lang: "ru", name: "Ссылка на презентацию"},
                    {lang: "en", name: "Ссылка на презентацию"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'imageArray',
                name: 'projectFilesIds',
                required: true,
                label: [
                    {lang: "ru", name: "Фото"},
                    {lang: "en", name: "Фото"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
                onlyJpgFormat:true
            },
            {
                type: 'dropdown',
                name: 'sources',
                freeTypeIndex: 3,
                label: [
                    {lang: "ru", name: "Откуда Вы узнали о «Зеленой премии»?"},
                    {lang: "en", name: "Откуда Вы узнали о «Зеленой премии»?"},
                ],
                placeholder: [
                    {lang: "ru", name: "Выберите значение"},
                    {lang: "en", name: "Выберите значение"},
                ],
                options: [{
                        label: [
                            {lang: "ru", name: "СМИ"},
                            {lang: "en", name: "СМИ"},
                        ],
                        value: 'СМИ',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Интернет"},
                            {lang: "en", name: "Интернет"},
                        ],
                        value: 'Интернет',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Друзья"},
                            {lang: "en", name: "Друзья"},
                        ],
                        value: 'Друзья',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Другое"},
                            {lang: "en", name: "Другое"},
                        ],
                        value: 'Другое',
                    }
                ],
                min: 2,
            },
            {
                type: 'cover',
                name: 'titleImage',
                required: true,
                label: [
                    {lang: "ru", name: "Обложка проекта"},
                    {lang: "en", name: "Обложка проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
            },
            // {
            //     type: 'agreement',
            //     name: 'agreement',
            //     required: true,
            //     label: [
            //         {lang: "ru", name: "Соглашение"},
            //         {lang: "en", name: "Agreement"},
            //     ],
            // },
        ]
    },
    //___________________________________________________________________________
    '9b6eb324b573410bbde5b570046433b2': {
        title: [
            {lang: "ru", name: "Форма заявки"},
            {lang: "en", name: "Форма заявки"},
        ],
        fields: [
            {
                type: 'text',
                name: 'team',
                required: true,
                label: [
                    {lang: "ru", name: "Организация"},
                    {lang: "en", name: "Организация"},
                ],
                placeholder: [
                    {lang: "ru", name: "Полное наименование организации "},
                    {lang: "en", name: "Полное наименование организации "},
                ]
            },
            {
                type: 'text',
                name: 'managers',
                required: true,
                label: [
                    {lang: "ru", name: "Руководители экоцентра"},
                    {lang: "en", name: "Руководители экоцентра"},
                ],
                placeholder: [
                    {lang: "ru", name: "ФИО представителя"},
                    {lang: "en", name: "ФИО представителя"},
                ]
            },
            {
                type: 'text',
                name: 'participantPhone',
                required: true,
                label: [
                    {lang: "ru", name: "Контактный телефон"},
                    {lang: "en", name: "Контактный телефон"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите контактный номер телефона"},
                    {lang: "en", name: "Укажите контактный номер телефона"},
                ],
                hint: [
                    {lang: "ru", name: "Формат телефона: +7-777-777-77-77"},
                    {lang: "en", name: "Формат телефона: +7-777-777-77-77"},
                ],
            },
            {
                type: 'text',
                name: 'participantEmail',
                required: true,
                label: [
                    {lang: "ru", name: "E-mail"},
                    {lang: "en", name: "E-mail"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите E-mail"},
                    {lang: "en", name: "Укажите E-mail"},
                ]
            },
            {
                type: 'text',
                name: 'projectTitle',
                required: true,
                max: 75,
                label: [
                    {lang: "ru", name: "Название экоцентра"},
                    {lang: "en", name: "Название экоцентра"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите название экоцентра/ сети экоцентров"},
                    {lang: "en", name: "Укажите название экоцентра/ сети экоцентров"},
                ],
                hint: [
                    {lang: "ru", name: "Максимум 75 символов включая пробелы"},
                    {lang: "en", name: "Максимум 75 символов включая пробелы"},
                ],
            },
            {
                type: 'text',
                name: 'geography',
                required: true,
                label: [
                    {lang: "ru", name: "География"},
                    {lang: "en", name: "География"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите где находится Ваш экоцентр"},
                    {lang: "en", name: "Укажите где находится Ваш экоцентр"},
                ]
            },
            {
                type: 'text',
                name: 'reach',
                required: true,
                label: [
                    {lang: "ru", name: "Охват"},
                    {lang: "en", name: "Охват"},
                ],
                placeholder: [
                    {lang: "ru", name: "Какое количество людей было затронуто экоцентром"},
                    {lang: "en", name: "Какое количество людей было затронуто экоцентром"},
                ]
            },
            {
                type: 'text',
                name: 'partners',
                label: [
                    {lang: "ru", name: "Партнеры проекта"},
                    {lang: "en", name: "Партнеры проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите партнеров Вашего проекта, если они есть"},
                    {lang: "en", name: "Укажите партнеров Вашего проекта, если они есть"},
                ]
            },
            {
                type: 'text',
                name: 'description',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Краткое описание экоцентра"},
                    {lang: "en", name: "Краткое описание экоцентра"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите Ваш экоцентр"},
                    {lang: "en", name: "Опишите Ваш экоцентр"},
                ],
                max: 200,
            },
            {
                type: 'text',
                name: 'description_2',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Подробное описание экоцентра"},
                    {lang: "en", name: "Подробное описание экоцентра"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите Ваш экоцентр, какие наиболее знаковые мероприятия вы провели в нем, какие проекты реализовали"},
                    {lang: "en", name: "Опишите Ваш экоцентр, какие наиболее знаковые мероприятия вы провели в нем, какие проекты реализовали"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'description_3',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Описание локаций экоцентра"},
                    {lang: "en", name: "Описание локаций экоцентра"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите из каких локаций состоит экологический центр (точка приема вторичного сырья, лекционная зона, просветительские экспозиции)"},
                    {lang: "en", name: "Опишите из каких локаций состоит экологический центр (точка приема вторичного сырья, лекционная зона, просветительские экспозиции)"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'plans',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Планы экоцентра на 2025 год"},
                    {lang: "en", name: "Планы экоцентра на 2025 год"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите планы на развитие экологического центра в 2025 году"},
                    {lang: "en", name: "Укажите планы на развитие экологического центра в 2025 году"},
                ],
                max: 400,
            },
            {
                type: 'text',
                name: 'result',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Результат"},
                    {lang: "en", name: "Результат"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите результат Вашего проекта, включая количество принятого от населения вторичного сырья"},
                    {lang: "en", name: "Опишите результат Вашего проекта, включая количество принятого от населения вторичного сырья"},
                ],
                hint: [
                    {lang: "ru", name: "(количественные, качественные показатели)"},
                    {lang: "en", name: "(количественные, качественные показатели)"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'count',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Количество видов вторсырья, принимаемого от населения в центре"},
                    {lang: "en", name: "Количество видов вторсырья, принимаемого от населения в центре "},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите количество видов вторичного сырья, перечислите их"},
                    {lang: "en", name: "Опишите количество видов вторичного сырья, перечислите их"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'links',
                required: true,
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылка на соц. сети, сайт"},
                    {lang: "en", name: "Ссылка на соц. сети, сайт"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'mediaLinks',
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылки на СМИ о проекте"},
                    {lang: "en", name: "Ссылки на СМИ о проекте"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'demoLink',
                label: [
                    {lang: "ru", name: "Ссылка на презентацию"},
                    {lang: "en", name: "Ссылка на презентацию"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'imageArray',
                name: 'projectFilesIds',
                required: true,
                label: [
                    {lang: "ru", name: "Фото"},
                    {lang: "en", name: "Фото"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
                onlyJpgFormat:true
            },
            {
                type: 'dropdown',
                name: 'sources',
                freeTypeIndex: 3,
                label: [
                    {lang: "ru", name: "Откуда Вы узнали о «Зеленой премии»?"},
                    {lang: "en", name: "Откуда Вы узнали о «Зеленой премии»?"},
                ],
                placeholder: [
                    {lang: "ru", name: "Выберите значение"},
                    {lang: "en", name: "Выберите значение"},
                ],
                options: [{
                        label: [
                            {lang: "ru", name: "СМИ"},
                            {lang: "en", name: "СМИ"},
                        ],
                        value: 'СМИ',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Интернет"},
                            {lang: "en", name: "Интернет"},
                        ],
                        value: 'Интернет',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Друзья"},
                            {lang: "en", name: "Друзья"},
                        ],
                        value: 'Друзья',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Другое"},
                            {lang: "en", name: "Другое"},
                        ],
                        value: 'Другое',
                    }
                ],
                min: 2,
            },
            {
                type: 'cover',
                name: 'titleImage',
                required: true,
                label: [
                    {lang: "ru", name: "Обложка проекта"},
                    {lang: "en", name: "Обложка проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
            },
            // {
            //     type: 'agreement',
            //     name: 'agreement',
            //     required: true,
            //     label: [
            //         {lang: "ru", name: "Соглашение"},
            //         {lang: "en", name: "Agreement"},
            //     ],
            // },
        ]
    },
    //___________________________________________________________________________
    'f56f6fe5f716482e8230146098423d51': {
        title: [
            {lang: "ru", name: "Форма заявки"},
            {lang: "en", name: "Форма заявки"},
        ],
        fields: [
            {
                type: 'text',
                name: 'projectAuthor',
                required: true,
                label: [
                    {lang: "ru", name: "Автор проекта"},
                    {lang: "en", name: "Автор проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "ФИО"},
                    {lang: "en", name: "ФИО"},
                ],
                 hint: [
                    {lang: "ru", name: "Можно добавить соавтора проекта"},
                    {lang: "en", name: "You can add a co-author to the project"},
                ],
            },
            {
                type: 'text',
                name: 'participantPhone',
                required: true,
                label: [
                    {lang: "ru", name: "Контактный телефон"},
                    {lang: "en", name: "Контактный телефон"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите контактный номер телефона"},
                    {lang: "en", name: "Укажите контактный номер телефона"},
                ],
                hint: [
                    {lang: "ru", name: "Формат телефона: +7-777-777-77-77"},
                    {lang: "en", name: "Формат телефона: +7-777-777-77-77"},
                ],
            },
            {
                type: 'text',
                name: 'participantEmail',
                required: true,
                label: [
                    {lang: "ru", name: "E-mail"},
                    {lang: "en", name: "E-mail"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите E-mail"},
                    {lang: "en", name: "Укажите E-mail"},
                ]
            },
            {
                type: 'text',
                name: 'team',
                required: true,
                label: [
                    {lang: "ru", name: "Организация "},
                    {lang: "en", name: "Организация "},
                ],
                placeholder: [
                    {lang: "ru", name: "Полное наименование организации "},
                    {lang: "en", name: "Полное наименование организации "},
                ]
            },
            {
                type: 'text',
                name: 'projectTitle',
                required: true,
                max: 75,
                label: [
                    {lang: "ru", name: "Название проекта"},
                    {lang: "en", name: "Название проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите название проекта"},
                    {lang: "en", name: "Укажите название проекта"},
                ],
                hint: [
                    {lang: "ru", name: "Максимум 75 символов включая пробелы"},
                    {lang: "en", name: "Максимум 75 символов включая пробелы"},
                ],
            },
            {
                type: 'text',
                name: 'geography',
                required: true,
                label: [
                    {lang: "ru", name: "География"},
                    {lang: "en", name: "География"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите где присутствует или реализован проект"},
                    {lang: "en", name: "Укажите где присутствует или реализован проект"},
                ]
            },
            {
                type: 'text',
                name: 'reach',
                label: [
                    {lang: "ru", name: "Охват"},
                    {lang: "en", name: "Охват"},
                ],
                placeholder: [
                    {lang: "ru", name: "Какое количество людей было затронуто проектом"},
                    {lang: "en", name: "Какое количество людей было затронуто проектом"},
                ]
            },
            {
                type: 'text',
                name: 'partners',
                label: [
                    {lang: "ru", name: "Партнеры проекта"},
                    {lang: "en", name: "Партнеры проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите партнеров Вашего проекта, если они есть"},
                    {lang: "en", name: "Укажите партнеров Вашего проекта, если они есть"},
                ]
            },
            {
                type: 'text',
                name: 'goal',
                required: true,
                label: [
                    {lang: "ru", name: "Цель проекта"},
                    {lang: "en", name: "Цель проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите цель Вашего проекта"},
                    {lang: "en", name: "Укажите цель Вашего проекта"},
                ]
            },
            {
                type: 'text',
                name: 'description',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Описание проекта"},
                    {lang: "en", name: "Описание проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите Ваш проект"},
                    {lang: "en", name: "Опишите Ваш проект"},
                ],
                max: 700,
            },
            {
                type: 'text',
                name: 'description_2',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Количественные результаты"},
                    {lang: "en", name: "Количественные результаты"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите результат Вашего проекта"},
                    {lang: "en", name: "Опишите результат Вашего проекта"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'description_3',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Качественные результаты"},
                    {lang: "en", name: "Качественные результаты"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите результат Вашего проекта"},
                    {lang: "en", name: "Опишите результат Вашего проекта"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'plans',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Планы проекта"},
                    {lang: "en", name: "Планы проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите планы на ваш проект"},
                    {lang: "en", name: "Укажите планы на ваш проект"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'links',
                required: true,
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылка на соц. сети, сайт"},
                    {lang: "en", name: "Ссылка на соц. сети, сайт"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'mediaLinks',
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылки на СМИ о проекте"},
                    {lang: "en", name: "Ссылки на СМИ о проекте"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'demoLink',
                label: [
                    {lang: "ru", name: "Ссылка на презентацию"},
                    {lang: "en", name: "Ссылка на презентацию"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'imageArray',
                name: 'projectFilesIds',
                required: true,
                label: [
                    {lang: "ru", name: "Фото"},
                    {lang: "en", name: "Фото"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
                onlyJpgFormat:true
            },
            {
                type: 'dropdown',
                name: 'sources',
                freeTypeIndex: 3,
                label: [
                    {lang: "ru", name: "Откуда Вы узнали о «Зеленой премии»?"},
                    {lang: "en", name: "Откуда Вы узнали о «Зеленой премии»?"},
                ],
                placeholder: [
                    {lang: "ru", name: "Выберите значение"},
                    {lang: "en", name: "Выберите значение"},
                ],
                options: [{
                        label: [
                            {lang: "ru", name: "СМИ"},
                            {lang: "en", name: "СМИ"},
                        ],
                        value: 'СМИ',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Интернет"},
                            {lang: "en", name: "Интернет"},
                        ],
                        value: 'Интернет',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Друзья"},
                            {lang: "en", name: "Друзья"},
                        ],
                        value: 'Друзья',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Другое"},
                            {lang: "en", name: "Другое"},
                        ],
                        value: 'Другое',
                    }
                ],
                min: 2,
            },
            {
                type: 'cover',
                name: 'titleImage',
                required: true,
                label: [
                    {lang: "ru", name: "Обложка проекта"},
                    {lang: "en", name: "Обложка проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
            },
            // {
            //     type: 'agreement',
            //     name: 'agreement',
            //     required: true,
            //     label: [
            //         {lang: "ru", name: "Соглашение"},
            //         {lang: "en", name: "Agreement"},
            //     ],
            // },
        ]
    },
    //___________________________________________________________________________
    '31235d97ac974536b6661c829a673e10': {
        title: [
            {lang: "ru", name: "Форма заявки"},
            {lang: "en", name: "Форма заявки"},
        ],
        fields: [
            {
                type: 'text',
                name: 'team',
                required: true,
                label: [
                    {lang: "ru", name: "Организация "},
                    {lang: "en", name: "Организация "},
                ],
                placeholder: [
                    {lang: "ru", name: "Полное наименование организации "},
                    {lang: "en", name: "Полное наименование организации "},
                ]
            },
            {
                type: 'text',
                name: 'contactName',
                required: true,
                label: [
                    {lang: "ru", name: "Контактное лицо"},
                    {lang: "en", name: "Контактное лицо"},
                ],
                placeholder: [
                    {lang: "ru", name: "ФИО представителя организации"},
                    {lang: "en", name: "ФИО представителя организации"},
                ]
            },
            {
                type: 'text',
                name: 'participantPhone',
                required: true,
                label: [
                    {lang: "ru", name: "Контактный телефон"},
                    {lang: "en", name: "Контактный телефон"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите контактный номер телефона"},
                    {lang: "en", name: "Укажите контактный номер телефона"},
                ],
                hint: [
                    {lang: "ru", name: "Формат телефона: +7-777-777-77-77"},
                    {lang: "en", name: "Формат телефона: +7-777-777-77-77"},
                ],
            },
            {
                type: 'text',
                name: 'participantEmail',
                required: true,
                label: [
                    {lang: "ru", name: "E-mail"},
                    {lang: "en", name: "E-mail"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите E-mail"},
                    {lang: "en", name: "Укажите E-mail"},
                ]
            },
            {
                type: 'text',
                name: 'projectTitle',
                required: true,
                max: 75,
                label: [
                    {lang: "ru", name: "Название проекта"},
                    {lang: "en", name: "Название проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите название проекта"},
                    {lang: "en", name: "Укажите название проекта"},
                ],
                hint: [
                    {lang: "ru", name: "Максимум 75 символов включая пробелы"},
                    {lang: "en", name: "Максимум 75 символов включая пробелы"},
                ],
            },
            {
                type: 'text',
                name: 'description',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Краткое описание Вашей деятельности"},
                    {lang: "en", name: "Краткое описание Вашей деятельности"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите Ваш проект"},
                    {lang: "en", name: "Опишите Ваш проект"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'geography',
                required: true,
                label: [
                    {lang: "ru", name: "Инновационность"},
                    {lang: "en", name: "Инновационность"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите где присутствует или реализован проект"},
                    {lang: "en", name: "Укажите где присутствует или реализован проект"},
                ],
                max: 700
            },
            {
                type: 'text',
                name: 'goal',
                required: true,
                label: [
                    {lang: "ru", name: "Цель"},
                    {lang: "en", name: "Цель"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите цель Вашего проекта"},
                    {lang: "en", name: "Укажите цель Вашего проекта"},
                ]
            },
            {
                type: 'text',
                name: 'result',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Результат"},
                    {lang: "en", name: "Результат"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите результат Вашего проекта"},
                    {lang: "en", name: "Опишите результат Вашего проекта"},
                ],
                max: 800,
            },
            {
                type: 'text',
                name: 'plans',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Планы проекта"},
                    {lang: "en", name: "Планы проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите планы на Ваш проект"},
                    {lang: "en", name: "Укажите планы на Ваш проект"},
                ],
                max: 300,
            },
            {
                type: 'text',
                name: 'reach',
                required: true,
                label: [
                    {lang: "ru", name: "Охват"},
                    {lang: "en", name: "Охват"},
                ],
                placeholder: [
                    {lang: "ru", name: "Какое количество людей было затронуто проектом"},
                    {lang: "en", name: "Какое количество людей было затронуто проектом"},
                ]
            },
            {
                type: 'text',
                name: 'partners',
                label: [
                    {lang: "ru", name: "Партнеры проекта"},
                    {lang: "en", name: "Партнеры проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите партнеров Вашего проекта, если они есть"},
                    {lang: "en", name: "Укажите партнеров Вашего проекта, если они есть"},
                ]
            },
            {
                type: 'text',
                name: 'links',
                required: true,
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылка на соц. сети, сайт"},
                    {lang: "en", name: "Ссылка на соц. сети, сайт"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'mediaLinks',
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылки на СМИ о проекте"},
                    {lang: "en", name: "Ссылки на СМИ о проекте"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'demoLink',
                label: [
                    {lang: "ru", name: "Ссылка на презентацию"},
                    {lang: "en", name: "Ссылка на презентацию"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'imageArray',
                name: 'projectFilesIds',
                required: true,
                label: [
                    {lang: "ru", name: "Фото"},
                    {lang: "en", name: "Фото"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
                onlyJpgFormat:true
            },
            {
                type: 'dropdown',
                name: 'sources',
                freeTypeIndex: 3,
                label: [
                    {lang: "ru", name: "Откуда Вы узнали о «Зеленой премии»?"},
                    {lang: "en", name: "Откуда Вы узнали о «Зеленой премии»?"},
                ],
                placeholder: [
                    {lang: "ru", name: "Выберите значение"},
                    {lang: "en", name: "Выберите значение"},
                ],
                options: [{
                        label: [
                            {lang: "ru", name: "СМИ"},
                            {lang: "en", name: "СМИ"},
                        ],
                        value: 'СМИ',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Интернет"},
                            {lang: "en", name: "Интернет"},
                        ],
                        value: 'Интернет',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Друзья"},
                            {lang: "en", name: "Друзья"},
                        ],
                        value: 'Друзья',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Другое"},
                            {lang: "en", name: "Другое"},
                        ],
                        value: 'Другое',
                    }
                ],
                min: 2,
            },
            {
                type: 'cover',
                name: 'titleImage',
                required: true,
                label: [
                    {lang: "ru", name: "Обложка проекта"},
                    {lang: "en", name: "Обложка проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
            },
            // {
            //     type: 'agreement',
            //     name: 'agreement',
            //     required: true,
            //     label: [
            //         {lang: "ru", name: "Соглашение"},
            //         {lang: "en", name: "Agreement"},
            //     ],
            // },
        ]
    },
}

export default GREEN_AWARD_FORMS;const GREEN_AWARD_FORMS = {
    '42493d2f77a84bf9a0f465451df71ff9': {
        title: [
            {lang: "ru", name: "Форма заявки"},
            {lang: "en", name: "Форма заявки"},
        ],
        fields: [
            {
                type: 'text',
                name: 'team',
                required: true,
                label: [
                    {lang: "ru", name: "Организация"},
                    {lang: "en", name: "Организация"},
                ],
                placeholder: [
                    {lang: "ru", name: "Полное наименование организации"},
                    {lang: "en", name: "Полное наименование организации"},
                ]
            },
            {
                type: 'text',
                name: 'contactName',
                required: true,
                label: [
                    {lang: "ru", name: "Контактное лицо"},
                    {lang: "en", name: "Контактное лицо"},
                ],
                placeholder: [
                    {lang: "ru", name: "ФИО представителя организации"},
                    {lang: "en", name: "ФИО представителя организации"},
                ]
            },
            {
                type: 'text',
                name: 'participantPhone',
                required: true,
                label: [
                    {lang: "ru", name: "Контактный телефон"},
                    {lang: "en", name: "Контактный телефон"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите контактный номер телефона"},
                    {lang: "en", name: "Укажите контактный номер телефона"},
                ],
                hint: [
                    {lang: "ru", name: "Формат телефона: +7-777-777-77-77"},
                    {lang: "en", name: "Формат телефона: +7-777-777-77-77"},
                ],
            },
            {
                type: 'text',
                name: 'participantEmail',
                required: true,
                label: [
                    {lang: "ru", name: "E-mail"},
                    {lang: "en", name: "E-mail"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите E-mail"},
                    {lang: "en", name: "Укажите E-mail"},
                ]
            },
            {
                type: 'text',
                name: 'projectTitle',
                required: true,
                max: 75,
                label: [
                    {lang: "ru", name: "Название проекта"},
                    {lang: "en", name: "Название проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите название проекта"},
                    {lang: "en", name: "Укажите название проекта"},
                ],
                hint: [
                    {lang: "ru", name: "Максимум 75 символов включая пробелы"},
                    {lang: "en", name: "Максимум 75 символов включая пробелы"},
                ],
            },
            {
                type: 'text',
                name: 'geography',
                required: true,
                label: [
                    {lang: "ru", name: "География"},
                    {lang: "en", name: "География"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите где присутствует или реализован проект"},
                    {lang: "en", name: "Укажите где присутствует или реализован проект"},
                ]
            },
            {
                type: 'text',
                name: 'reach',
                required: true,
                label: [
                    {lang: "ru", name: "Охват"},
                    {lang: "en", name: "Охват"},
                ],
                placeholder: [
                    {lang: "ru", name: "Какое количество людей было затронуто проектом"},
                    {lang: "en", name: "Какое количество людей было затронуто проектом"},
                ]
            },
            {
                type: 'text',
                name: 'partners',
                label: [
                    {lang: "ru", name: "Партнеры проекта"},
                    {lang: "en", name: "Партнеры проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите партнеров Вашего проекта, если они есть"},
                    {lang: "en", name: "Укажите партнеров Вашего проекта, если они есть"},
                ]
            },
            {
                type: 'text',
                name: 'goal',
                required: true,
                label: [
                    {lang: "ru", name: "Цель"},
                    {lang: "en", name: "Цель"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите цель Вашего проекта"},
                    {lang: "en", name: "Укажите цель Вашего проекта"},
                ]
            },
            {
                type: 'text',
                name: 'description',
                required: true,
                multiline: true,
                max: 500,
                label: [
                    {lang: "ru", name: "Описание"},
                    {lang: "en", name: "Описание"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите Ваш проект"},
                    {lang: "en", name: "Опишите Ваш проект"},
                ],
            },
            {
                type: 'text',
                name: 'plans',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Планы проекта"},
                    {lang: "en", name: "Планы проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите планы на Ваш проект"},
                    {lang: "en", name: "Укажите планы на Ваш проект"},
                ],
                max: 300,
            },
            {
                type: 'text',
                name: 'result',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Результат"},
                    {lang: "en", name: "Результат"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите результат Вашего проекта"},
                    {lang: "en", name: "Опишите результат Вашего проекта"},
                ],
                max: 800,
            },
            {
                type: 'text',
                name: 'links',
                required: true,
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылка на соц. сети, сайт"},
                    {lang: "en", name: "Ссылка на соц. сети, сайт"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
             {
                type: 'text',
                name: 'mediaLinks',
                multipleValues: true,
                label: [
                    { lang: "ru", name: "Ссылки на СМИ о проекте" },
                    { lang: "en", name: "Ссылки на СМИ о проекте" },
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'demoLink',
                label: [
                    {lang: "ru", name: "Ссылка на презентацию"},
                    {lang: "en", name: "Ссылка на презентацию"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'imageArray',
                name: 'projectFilesIds',
                required: true,
                label: [
                    {lang: "ru", name: "Фото"},
                    {lang: "en", name: "Фото"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
                onlyJpgFormat:true
            },
            {
                type: 'dropdown',
                name: 'sources',
                freeTypeIndex: 3,
                label: [
                    {lang: "ru", name: "Откуда Вы узнали о «Зеленой премии»?"},
                    {lang: "en", name: "Откуда Вы узнали о «Зеленой премии»?"},
                ],
                placeholder: [
                    {lang: "ru", name: "Выберите значение"},
                    {lang: "en", name: "Выберите значение"},
                ],
                options: [{
                        label: [
                            {lang: "ru", name: "СМИ"},
                            {lang: "en", name: "СМИ"},
                        ],
                        value: 'СМИ',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Интернет"},
                            {lang: "en", name: "Интернет"},
                        ],
                        value: 'Интернет',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Друзья"},
                            {lang: "en", name: "Друзья"},
                        ],
                        value: 'Друзья',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Другое"},
                            {lang: "en", name: "Другое"},
                        ],
                        value: 'Другое',
                    }
                ],
                min: 2,
            },
            {
                type: 'cover',
                name: 'titleImage',
                required: true,
                label: [
                    {lang: "ru", name: "Обложка проекта"},
                    {lang: "en", name: "Обложка проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
            },
            // {
            //     type: 'agreement',
            //     name: 'agreement',
            //     required: true,
            //     label: [
            //         {lang: "ru", name: "Соглашение"},
            //         {lang: "en", name: "Agreement"},
            //     ],
            // },
        ]
    },
    //___________________________________________________________________________
    '8b7c88b557dd4a5b90dad959b205104e': {
        title: [
            {lang: "ru", name: "Форма заявки"},
            {lang: "en", name: "Форма заявки"},
        ],
        fields: [
            {
                type: 'text',
                name: 'university',
                required: true,
                label: [
                    {lang: "ru", name: "Образовательное учреждение"},
                    {lang: "en", name: "Образовательное учреждение"},
                ],
                placeholder: [
                    {lang: "ru", name: "Полное наименование организации"},
                    {lang: "en", name: "Полное наименование организации"},
                ]
            },
            {
                type: 'text',
                name: 'projectAuthor',
                required: true,
                label: [
                    {lang: "ru", name: "Автор проекта"},
                    {lang: "en", name: "Автор проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "ФИО"},
                    {lang: "en", name: "ФИО"},
                ],
                hint: [
                    {lang: "ru", name: "Можно добавить соавтора проекта"},
                    {lang: "en", name: "You can add a co-author to the project"},
                ],
            },
            {
                type: 'text',
                name: 'participantPhone',
                required: true,
                label: [
                    {lang: "ru", name: "Контактный телефон"},
                    {lang: "en", name: "Контактный телефон"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите контактный номер телефона"},
                    {lang: "en", name: "Укажите контактный номер телефона"},
                ],
                hint: [
                    {lang: "ru", name: "Формат телефона: +7-777-777-77-77"},
                    {lang: "en", name: "Формат телефона: +7-777-777-77-77"},
                ],
            },
            {
                type: 'text',
                name: 'participantEmail',
                required: true,
                label: [
                    {lang: "ru", name: "E-mail"},
                    {lang: "en", name: "E-mail"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите E-mail"},
                    {lang: "en", name: "Укажите E-mail"},
                ]
            },
            {
                type: 'text',
                name: 'projectTitle',
                required: true,
                max: 75,
                label: [
                    {lang: "ru", name: "Название проекта"},
                    {lang: "en", name: "Название проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите название проекта"},
                    {lang: "en", name: "Укажите название проекта"},
                ],
                hint: [
                    {lang: "ru", name: "Максимум 75 символов включая пробелы"},
                    {lang: "en", name: "Максимум 75 символов включая пробелы"},
                ],
            },
            {
                type: 'text',
                name: 'geography',
                required: true,
                label: [
                    {lang: "ru", name: "География"},
                    {lang: "en", name: "География"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите где присутствует или реализован проект"},
                    {lang: "en", name: "Укажите где присутствует или реализован проект"},
                ]
            },
            {
                type: 'text',
                name: 'reach',
                required: true,
                label: [
                    {lang: "ru", name: "Охват"},
                    {lang: "en", name: "Охват"},
                ],
                placeholder: [
                    {lang: "ru", name: "Какое количество людей было затронуто проектом"},
                    {lang: "en", name: "Какое количество людей было затронуто проектом"},
                ]
            },
            {
                type: 'text',
                name: 'partners',
                label: [
                    {lang: "ru", name: "Партнеры проекта"},
                    {lang: "en", name: "Партнеры проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите партнеров Вашего проекта, если они есть"},
                    {lang: "en", name: "Укажите партнеров Вашего проекта, если они есть"},
                ]
            },
            {
                type: 'text',
                name: 'goal',
                required: true,
                label: [
                    {lang: "ru", name: "Цель"},
                    {lang: "en", name: "Цель"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите цель Вашего проекта"},
                    {lang: "en", name: "Укажите цель Вашего проекта"},
                ]
            },
            {
                type: 'text',
                name: 'description',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Описание"},
                    {lang: "en", name: "Описание"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите Ваш проект"},
                    {lang: "en", name: "Опишите Ваш проект"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'plans',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Планы проекта"},
                    {lang: "en", name: "Планы проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите планы на Ваш проект"},
                    {lang: "en", name: "Укажите планы на Ваш проект"},
                ],
                max: 300,
            },
            {
                type: 'text',
                name: 'result',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Результат"},
                    {lang: "en", name: "Результат"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите результат Вашего проекта"},
                    {lang: "en", name: "Опишите результат Вашего проекта"},
                ],
                max: 800,
            },
            {
                type: 'text',
                name: 'links',
                required: true,
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылка на соц. сети, сайт"},
                    {lang: "en", name: "Ссылка на соц. сети, сайт"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'mediaLinks',
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылки на СМИ о проекте"},
                    {lang: "en", name: "Ссылки на СМИ о проекте"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'demoLink',
                label: [
                    {lang: "ru", name: "Ссылка на презентацию"},
                    {lang: "en", name: "Ссылка на презентацию"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'imageArray',
                name: 'projectFilesIds',
                required: true,
                label: [
                    {lang: "ru", name: "Фото"},
                    {lang: "en", name: "Фото"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
                onlyJpgFormat:true
            },
            {
                type: 'dropdown',
                name: 'sources',
                freeTypeIndex: 3,
                label: [
                    {lang: "ru", name: "Откуда Вы узнали о «Зеленой премии»?"},
                    {lang: "en", name: "Откуда Вы узнали о «Зеленой премии»?"},
                ],
                placeholder: [
                    {lang: "ru", name: "Выберите значение"},
                    {lang: "en", name: "Выберите значение"},
                ],
                options: [{
                        label: [
                            {lang: "ru", name: "СМИ"},
                            {lang: "en", name: "СМИ"},
                        ],
                        value: 'СМИ',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Интернет"},
                            {lang: "en", name: "Интернет"},
                        ],
                        value: 'Интернет',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Друзья"},
                            {lang: "en", name: "Друзья"},
                        ],
                        value: 'Друзья',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Другое"},
                            {lang: "en", name: "Другое"},
                        ],
                        value: 'Другое',
                    }
                ],
                min: 2,
            },
            {
                type: 'cover',
                name: 'titleImage',
                required: true,
                label: [
                    {lang: "ru", name: "Обложка проекта"},
                    {lang: "en", name: "Обложка проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
            },
            // {
            //     type: 'agreement',
            //     name: 'agreement',
            //     required: true,
            //     label: [
            //         {lang: "ru", name: "Соглашение"},
            //         {lang: "en", name: "Agreement"},
            //     ],
            // },
        ],
        
    },
    //___________________________________________________________________________
    '8edf1a5a40e94e489fc79a7de29e864c': {
        title: [
            {lang: "ru", name: "Форма заявки"},
            {lang: "en", name: "Форма заявки"},
        ],
        fields: [
            {
                type: 'text',
                name: 'team',
                required: true,
                label: [
                    {lang: "ru", name: "Организация"},
                    {lang: "en", name: "Организация"},
                ],
                placeholder: [
                    {lang: "ru", name: "Полное наименование организации"},
                    {lang: "en", name: "Полное наименование организации"},
                ]
            },
            {
                type: 'text',
                name: 'contactName',
                required: true,
                label: [
                    {lang: "ru", name: "Контактное лицо"},
                    {lang: "en", name: "Контактное лицо"},
                ],
                placeholder: [
                    {lang: "ru", name: "ФИО представителя организации"},
                    {lang: "en", name: "ФИО представителя организации"},
                ]
            },
            {
                type: 'text',
                name: 'participantPhone',
                required: true,
                label: [
                    {lang: "ru", name: "Контактный телефон"},
                    {lang: "en", name: "Контактный телефон"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите контактный номер телефона"},
                    {lang: "en", name: "Укажите контактный номер телефона"},
                ],
                hint: [
                    {lang: "ru", name: "Формат телефона: +7-777-777-77-77"},
                    {lang: "en", name: "Формат телефона: +7-777-777-77-77"},
                ],
            },
            {
                type: 'text',
                name: 'participantEmail',
                required: true,
                label: [
                    {lang: "ru", name: "E-mail"},
                    {lang: "en", name: "E-mail"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите E-mail"},
                    {lang: "en", name: "Укажите E-mail"},
                ]
            },
            {
                type: 'text',
                name: 'projectTitle',
                required: true,
                max: 75,
                label: [
                    {lang: "ru", name: "Название проекта"},
                    {lang: "en", name: "Название проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите название проекта"},
                    {lang: "en", name: "Укажите название проекта"},
                ],
                hint: [
                    {lang: "ru", name: "Максимум 75 символов включая пробелы"},
                    {lang: "en", name: "Максимум 75 символов включая пробелы"},
                ],
            },
            {
                type: 'text',
                name: 'geography',
                required: true,
                label: [
                    {lang: "ru", name: "География"},
                    {lang: "en", name: "География"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите где присутствует или реализован проект"},
                    {lang: "en", name: "Укажите где присутствует или реализован проект"},
                ]
            },
            {
                type: 'text',
                name: 'reach',
                required: true,
                label: [
                    {lang: "ru", name: "Охват"},
                    {lang: "en", name: "Охват"},
                ],
                placeholder: [
                    {lang: "ru", name: "Какое количество людей было затронуто проектом"},
                    {lang: "en", name: "Какое количество людей было затронуто проектом"},
                ]
            },
            {
                type: 'text',
                name: 'partners',
                label: [
                    {lang: "ru", name: "Партнеры проекта"},
                    {lang: "en", name: "Партнеры проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите партнеров Вашего проекта, если они есть"},
                    {lang: "en", name: "Укажите партнеров Вашего проекта, если они есть"},
                ]
            },
            {
                type: 'text',
                name: 'goal',
                required: true,
                label: [
                    {lang: "ru", name: "Цель"},
                    {lang: "en", name: "Цель"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите цель Вашего проекта"},
                    {lang: "en", name: "Укажите цель Вашего проекта"},
                ]
            },
            {
                type: 'text',
                name: 'description',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Описание"},
                    {lang: "en", name: "Описание"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите Ваш проект"},
                    {lang: "en", name: "Опишите Ваш проект"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'plans',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Планы проекта"},
                    {lang: "en", name: "Планы проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите планы на Ваш проект"},
                    {lang: "en", name: "Укажите планы на Ваш проект"},
                ],
                max: 300,
            },
            {
                type: 'text',
                name: 'result',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Результат"},
                    {lang: "en", name: "Результат"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите результат Вашего проекта"},
                    {lang: "en", name: "Опишите результат Вашего проекта"},
                ],
                max: 800,
            },
            {
                type: 'text',
                name: 'links',
                required: true,
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылка на соц. сети, сайт"},
                    {lang: "en", name: "Ссылка на соц. сети, сайт"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'mediaLinks',
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылки на СМИ о проекте"},
                    {lang: "en", name: "Ссылки на СМИ о проекте"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'demoLink',
                label: [
                    {lang: "ru", name: "Ссылка на презентацию"},
                    {lang: "en", name: "Ссылка на презентацию"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'imageArray',
                name: 'projectFilesIds',
                required: true,
                label: [
                    {lang: "ru", name: "Фото"},
                    {lang: "en", name: "Фото"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
                onlyJpgFormat:true
            },
            {
                type: 'dropdown',
                name: 'sources',
                freeTypeIndex: 3,
                label: [
                    {lang: "ru", name: "Откуда Вы узнали о «Зеленой премии»?"},
                    {lang: "en", name: "Откуда Вы узнали о «Зеленой премии»?"},
                ],
                placeholder: [
                    {lang: "ru", name: "Выберите значение"},
                    {lang: "en", name: "Выберите значение"},
                ],
                options: [{
                        label: [
                            {lang: "ru", name: "СМИ"},
                            {lang: "en", name: "СМИ"},
                        ],
                        value: 'СМИ',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Интернет"},
                            {lang: "en", name: "Интернет"},
                        ],
                        value: 'Интернет',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Друзья"},
                            {lang: "en", name: "Друзья"},
                        ],
                        value: 'Друзья',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Другое"},
                            {lang: "en", name: "Другое"},
                        ],
                        value: 'Другое',
                    }
                ],
                min: 2,
            },
            {
                type: 'cover',
                name: 'titleImage',
                required: true,
                label: [
                    {lang: "ru", name: "Обложка проекта"},
                    {lang: "en", name: "Обложка проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
            },
            // {
            //     type: 'agreement',
            //     name: 'agreement',
            //     required: true,
            //     label: [
            //         {lang: "ru", name: "Соглашение"},
            //         {lang: "en", name: "Agreement"},
            //     ],
            // },
        ]
    },
    //___________________________________________________________________________
    '8461cb11b0724f6790280fd1c159137f': {
        title: [
            {lang: "ru", name: "Форма заявки"},
            {lang: "en", name: "Форма заявки"},
        ],
        fields: [
            {
                type: 'text',
                name: 'university',
                required: true,
                label: [
                    {lang: "ru", name: "Образовательное учреждение"},
                    {lang: "en", name: "Образовательное учреждение"},
                ],
                placeholder: [
                    {lang: "ru", name: "Полное наименование организации"},
                    {lang: "en", name: "Полное наименование организации"},
                ]
            },
            {
                type: 'text',
                name: 'projectAuthor',
                required: true,
                label: [
                    {lang: "ru", name: "Автор проекта"},
                    {lang: "en", name: "Автор проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "ФИО"},
                    {lang: "en", name: "ФИО"},
                ],
                 hint: [
                    {lang: "ru", name: "Можно добавить соавтора проекта"},
                    {lang: "en", name: "You can add a co-author to the project"},
                ],
            },
            {
                type: 'text',
                name: 'participantPhone',
                required: true,
                label: [
                    {lang: "ru", name: "Контактный телефон"},
                    {lang: "en", name: "Контактный телефон"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите контактный номер телефона"},
                    {lang: "en", name: "Укажите контактный номер телефона"},
                ],
                hint: [
                    {lang: "ru", name: "Формат телефона: +7-777-777-77-77"},
                    {lang: "en", name: "Формат телефона: +7-777-777-77-77"},
                ],
            },
            {
                type: 'text',
                name: 'participantEmail',
                required: true,
                label: [
                    {lang: "ru", name: "E-mail"},
                    {lang: "en", name: "E-mail"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите E-mail"},
                    {lang: "en", name: "Укажите E-mail"},
                ]
            },
            {
                type: 'text',
                name: 'projectTitle',
                required: true,
                max: 75,
                label: [
                    {lang: "ru", name: "Название проекта"},
                    {lang: "en", name: "Название проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите название проекта"},
                    {lang: "en", name: "Укажите название проекта"},
                ],
                hint: [
                    {lang: "ru", name: "Максимум 75 символов включая пробелы"},
                    {lang: "en", name: "Максимум 75 символов включая пробелы"},
                ],
            },
            {
                type: 'text',
                name: 'geography',
                required: true,
                label: [
                    {lang: "ru", name: "География"},
                    {lang: "en", name: "География"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите где присутствует или реализован проект"},
                    {lang: "en", name: "Укажите где присутствует или реализован проект"},
                ]
            },
            {
                type: 'text',
                name: 'reach',
                required: true,
                label: [
                    {lang: "ru", name: "Охват"},
                    {lang: "en", name: "Охват"},
                ],
                placeholder: [
                    {lang: "ru", name: "Какое количество людей было затронуто проектом"},
                    {lang: "en", name: "Какое количество людей было затронуто проектом"},
                ]
            },
            {
                type: 'text',
                name: 'partners',
                label: [
                    {lang: "ru", name: "Партнеры проекта"},
                    {lang: "en", name: "Партнеры проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите партнеров Вашего проекта, если они есть"},
                    {lang: "en", name: "Укажите партнеров Вашего проекта, если они есть"},
                ]
            },
            {
                type: 'text',
                name: 'goal',
                required: true,
                label: [
                    {lang: "ru", name: "Цель"},
                    {lang: "en", name: "Цель"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите цель Вашего проекта"},
                    {lang: "en", name: "Укажите цель Вашего проекта"},
                ]
            },
            {
                type: 'text',
                name: 'description',
                required: true,
                multiline: true,
                label: [
                    {lang: "ru", name: "Описание"},
                    {lang: "en", name: "Описание"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите Ваш проект"},
                    {lang: "en", name: "Опишите Ваш проект"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'plans',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Планы проекта"},
                    {lang: "en", name: "Планы проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите планы на Ваш проект"},
                    {lang: "en", name: "Укажите планы на Ваш проект"},
                ],
                max: 300,
            },
            {
                type: 'text',
                name: 'result',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Результат"},
                    {lang: "en", name: "Результат"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите результат Вашего проекта"},
                    {lang: "en", name: "Опишите результат Вашего проекта"},
                ],
                max: 800,
            },
            {
                type: 'text',
                name: 'links',
                required: true,
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылка на соц. сети, сайт"},
                    {lang: "en", name: "Ссылка на соц. сети, сайт"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'mediaLinks',
                multipleValues: true,
                required: true,
                label: [
                    {lang: "ru", name: "Ссылки на СМИ о проекте"},
                    {lang: "en", name: "Ссылки на СМИ о проекте"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'demoLink',
                label: [
                    {lang: "ru", name: "Ссылка на презентацию"},
                    {lang: "en", name: "Ссылка на презентацию"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'imageArray',
                name: 'projectFilesIds',
                required: true,
                label: [
                    {lang: "ru", name: "Фото"},
                    {lang: "en", name: "Фото"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
                onlyJpgFormat:true
            },
            {
                type: 'dropdown',
                name: 'sources',
                freeTypeIndex: 3,
                label: [
                    {lang: "ru", name: "Откуда Вы узнали о «Зеленой премии»?"},
                    {lang: "en", name: "Откуда Вы узнали о «Зеленой премии»?"},
                ],
                placeholder: [
                    {lang: "ru", name: "Выберите значение"},
                    {lang: "en", name: "Выберите значение"},
                ],
                options: [{
                        label: [
                            {lang: "ru", name: "СМИ"},
                            {lang: "en", name: "СМИ"},
                        ],
                        value: 'СМИ',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Интернет"},
                            {lang: "en", name: "Интернет"},
                        ],
                        value: 'Интернет',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Друзья"},
                            {lang: "en", name: "Друзья"},
                        ],
                        value: 'Друзья',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Другое"},
                            {lang: "en", name: "Другое"},
                        ],
                        value: 'Другое',
                    }
                ],
                min: 2,
            },
            {
                type: 'cover',
                name: 'titleImage',
                required: true,
                label: [
                    {lang: "ru", name: "Обложка проекта"},
                    {lang: "en", name: "Обложка проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
            },
            // {
            //     type: 'agreement',
            //     name: 'agreement',
            //     required: true,
            //     label: [
            //         {lang: "ru", name: "Соглашение"},
            //         {lang: "en", name: "Agreement"},
            //     ],
            // },
        ]
    },
    //___________________________________________________________________________
    'c9b7f61ee5e349f495dfe237dd3109df': {
        title: [
            {lang: "ru", name: "Форма заявки"},
            {lang: "en", name: "Форма заявки"},
        ],
        fields: [
            {
                type: 'text',
                name: 'team',
                required: true,
                label: [
                    {lang: "ru", name: "Организация"},
                    {lang: "en", name: "Организация"},
                ],
                placeholder: [
                    {lang: "ru", name: "Полное наименование организации"},
                    {lang: "en", name: "Полное наименование организации"},
                ]
            },
            {
                type: 'text',
                name: 'projectAuthor',
                required: true,
                label: [
                    {lang: "ru", name: "Автор проекта"},
                    {lang: "en", name: "Автор проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "ФИО"},
                    {lang: "en", name: "ФИО"},
                ],
                 hint: [
                    {lang: "ru", name: "Можно добавить соавтора проекта"},
                    {lang: "en", name: "You can add a co-author to the project"},
                ],
            },
            {
                type: 'text',
                name: 'participantPhone',
                required: true,
                label: [
                    {lang: "ru", name: "Контактный телефон"},
                    {lang: "en", name: "Контактный телефон"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите контактный номер телефона"},
                    {lang: "en", name: "Укажите контактный номер телефона"},
                ],
                hint: [
                    {lang: "ru", name: "Формат телефона: +7-777-777-77-77"},
                    {lang: "en", name: "Формат телефона: +7-777-777-77-77"},
                ],
            },
            {
                type: 'text',
                name: 'participantEmail',
                required: true,
                label: [
                    {lang: "ru", name: "E-mail"},
                    {lang: "en", name: "E-mail"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите E-mail"},
                    {lang: "en", name: "Укажите E-mail"},
                ]
            },
            {
                type: 'text',
                name: 'projectTitle',
                required: true,
                max: 75,
                label: [
                    {lang: "ru", name: "Название проекта"},
                    {lang: "en", name: "Название проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите название проекта"},
                    {lang: "en", name: "Укажите название проекта"},
                ],
                hint: [
                    {lang: "ru", name: "Максимум 75 символов включая пробелы"},
                    {lang: "en", name: "Максимум 75 символов включая пробелы"},
                ],
            },
            {
                type: 'text',
                name: 'geography',
                required: true,
                label: [
                    {lang: "ru", name: "География"},
                    {lang: "en", name: "География"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите где присутствует или реализован проект"},
                    {lang: "en", name: "Укажите где присутствует или реализован проект"},
                ]
            },
            {
                type: 'text',
                name: 'reach',
                required: true,
                label: [
                    {lang: "ru", name: "Охват"},
                    {lang: "en", name: "Охват"},
                ],
                placeholder: [
                    {lang: "ru", name: "Какое количество людей было затронуто проектом"},
                    {lang: "en", name: "Какое количество людей было затронуто проектом"},
                ]
            },
            {
                type: 'text',
                name: 'partners',
                label: [
                    {lang: "ru", name: "Партнеры проекта"},
                    {lang: "en", name: "Партнеры проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите партнеров Вашего проекта, если они есть"},
                    {lang: "en", name: "Укажите партнеров Вашего проекта, если они есть"},
                ]
            },
            {
                type: 'text',
                name: 'description',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Описание"},
                    {lang: "en", name: "Описание"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите Ваш проект"},
                    {lang: "en", name: "Опишите Ваш проект"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'plans',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Планы проекта"},
                    {lang: "en", name: "Планы проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите планы на Ваш проект"},
                    {lang: "en", name: "Укажите планы на Ваш проект"},
                ],
                max: 400,
            },
            {
                type: 'text',
                name: 'result',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Результат"},
                    {lang: "en", name: "Результат"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите результат Вашего проекта"},
                    {lang: "en", name: "Опишите результат Вашего проекта"},
                ],
                max: 800,
            },
            {
                type: 'text',
                name: 'links',
                required: true,
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылка на соц. сети, сайт"},
                    {lang: "en", name: "Ссылка на соц. сети, сайт"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'mediaLinks',
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылки на СМИ о проекте"},
                    {lang: "en", name: "Ссылки на СМИ о проекте"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'demoLink',
                label: [
                    {lang: "ru", name: "Ссылка на презентацию"},
                    {lang: "en", name: "Ссылка на презентацию"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'imageArray',
                name: 'projectFilesIds',
                required: true,
                label: [
                    {lang: "ru", name: "Фото"},
                    {lang: "en", name: "Фото"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
                onlyJpgFormat:true
            },
            {
                type: 'dropdown',
                name: 'sources',
                freeTypeIndex: 3,
                label: [
                    {lang: "ru", name: "Откуда Вы узнали о «Зеленой премии»?"},
                    {lang: "en", name: "Откуда Вы узнали о «Зеленой премии»?"},
                ],
                placeholder: [
                    {lang: "ru", name: "Выберите значение"},
                    {lang: "en", name: "Выберите значение"},
                ],
                options: [{
                        label: [
                            {lang: "ru", name: "СМИ"},
                            {lang: "en", name: "СМИ"},
                        ],
                        value: 'СМИ',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Интернет"},
                            {lang: "en", name: "Интернет"},
                        ],
                        value: 'Интернет',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Друзья"},
                            {lang: "en", name: "Друзья"},
                        ],
                        value: 'Друзья',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Другое"},
                            {lang: "en", name: "Другое"},
                        ],
                        value: 'Другое',
                    }
                ],
                min: 2,
            },
            {
                type: 'cover',
                name: 'titleImage',
                required: true,
                label: [
                    {lang: "ru", name: "Обложка проекта"},
                    {lang: "en", name: "Обложка проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
            },
            // {
            //     type: 'agreement',
            //     name: 'agreement',
            //     required: true,
            //     label: [
            //         {lang: "ru", name: "Соглашение"},
            //         {lang: "en", name: "Agreement"},
            //     ],
            // },
        ]
    },
    //___________________________________________________________________________
    '9b26f859c5734929bdbc3f21a6570a10': {
        title: [
            { lang: "ru", name: "Форма заявки" },
            { lang: "en", name: "Форма заявки" },
        ],
        fields: [
            {
                type: 'text',
                name: 'team',
                required: true,
                label: [
                    { lang: "ru", name: "Организация" },
                    { lang: "en", name: "Организация" },
                ],
                placeholder: [
                    { lang: "ru", name: "Полное наименование организации" },
                    { lang: "en", name: "Полное наименование организации" },
                ],
            },
            {
                type: 'text',
                name: 'projectTitle',
                required: true,
                max: 75,
                label: [
                    { lang: "ru", name: "Название проекта" },
                    { lang: "en", name: "Название проекта" },
                ],
                placeholder: [
                    { lang: "ru", name: "Укажите название проекта" },
                    { lang: "en", name: "Укажите название проекта" },
                ],
                hint: [
                    {lang: "ru", name: "Максимум 75 символов включая пробелы"},
                    {lang: "en", name: "Максимум 75 символов включая пробелы"},
                ],
            },
            {
                type: 'text',
                name: 'projectAuthor',
                required: true,
                label: [
                    { lang: "ru", name: "Автор проекта" },
                    { lang: "en", name: "Автор проекта" },
                ],
                placeholder: [
                    { lang: "ru", name: "ФИО представителей" },
                    { lang: "en", name: "ФИО представителей" },
                ],
                 hint: [
                    {lang: "ru", name: "Можно добавить соавтора проекта"},
                    {lang: "en", name: "You can add a co-author to the project"},
                ],
            },
            {
                type: 'text',
                name: 'participantPhone',
                required: true,
                label: [
                    { lang: "ru", name: "Контактный телефон" },
                    { lang: "en", name: "Контактный телефон" },
                ],
                placeholder: [
                    { lang: "ru", name: "Укажите контактный номер телефона" },
                    { lang: "en", name: "Укажите контактный номер телефона" },
                ],
                hint: [
                    {lang: "ru", name: "Формат телефона: +7-777-777-77-77"},
                    {lang: "en", name: "Формат телефона: +7-777-777-77-77"},
                ],
            },
            {
                type: 'text',
                name: 'participantEmail',
                required: true,
                label: [
                    { lang: "ru", name: "E-mail" },
                    { lang: "en", name: "E-mail" },
                ],
                placeholder: [
                    { lang: "ru", name: "Укажите E-mail" },
                    { lang: "en", name: "Укажите E-mail" },
                ],
            },
            {
                type: 'text',
                name: 'geography',
                required: true,
                label: [
                    { lang: "ru", name: "География" },
                    { lang: "en", name: "География" },
                ],
                placeholder: [
                    { lang: "ru", name: "Укажите где присутствует или реализован проект" },
                    { lang: "en", name: "Укажите где присутствует или реализован проект" },
                ],
            },
            {
                type: 'text',
                name: 'reach',
                required: true,
                label: [
                    { lang: "ru", name: "Охват" },
                    { lang: "en", name: "Охват" },
                ],
                placeholder: [
                    { lang: "ru", name: "Какое количество людей было затронуто проектом" },
                    { lang: "en", name: "Какое количество людей было затронуто проектом" },
                ],
            },
            {
                type: 'text',
                name: 'partners',
                label: [
                    { lang: "ru", name: "Партнеры проекта" },
                    { lang: "en", name: "Партнеры проекта" },
                ],
                placeholder: [
                    { lang: "ru", name: "Укажите партнеров Вашего проекта, если они есть" },
                    { lang: "en", name: "Укажите партнеров Вашего проекта, если они есть" },
                ],
            },
            {
                type: 'text',
                name: 'description',
                multiline: true,
                required: true,
                label: [
                    { lang: "ru", name: "Описание" },
                    { lang: "en", name: "Описание" },
                ],
                placeholder: [
                    { lang: "ru", name: "Опишите Ваш проект" },
                    { lang: "en", name: "Опишите Ваш проект" },
                ],
            },
            {
                type: 'text',
                name: 'plans',
                multiline: true,
                required: true,
                label: [
                    { lang: "ru", name: "Планы проекта" },
                    { lang: "en", name: "Планы проекта" },
                ],
                placeholder: [
                    { lang: "ru", name: "Укажите планы на Ваш проект" },
                    { lang: "en", name: "Укажите планы на Ваш проект" },
                ],
            },
            {
                type: 'text',
                name: 'result_2',
                multiline: true,
                required: true,
                label: [
                    { lang: "ru", name: "Результаты" },
                    { lang: "en", name: "Результаты" },
                ],
                placeholder: [
                    { lang: "ru", name: "Опишите результат Вашего проекта" },
                    { lang: "en", name: "Опишите результат Вашего проекта" },
                ],
                hint: [
                    { lang: "ru", name: "объем сбыта производимой продукции/оказываемых услуг" },
                    { lang: "en", name: "объем сбыта производимой продукции/оказываемых услуг" },
                ],
                max: 400
            },
            {
                type: 'text',
                name: 'indicators',
                multiline: true,
                required: true,
                label: [
                    { lang: "ru", name: "Финансовые показатели деятельности бизнеса" },
                    { lang: "en", name: "Финансовые показатели деятельности бизнеса" },
                ],
                placeholder: [
                    { lang: "ru", name: "Опишите финансовые показатели Вашего проекта" },
                    { lang: "en", name: "Опишите финансовые показатели Вашего проекта" },
                ],
                max: 400
            },
            {
                type: 'text',
                name: 'links',
                required: true,
                multipleValues: true,
                label: [
                    { lang: "ru", name: "Ссылка на соц. сети, сайт" },
                    { lang: "en", name: "Ссылка на соц. сети, сайт" },
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'mediaLinks',
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылки на СМИ о проекте"},
                    {lang: "en", name: "Ссылки на СМИ о проекте"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'demoLink',
                label: [
                    { lang: "ru", name: "Ссылка на презентацию" },
                    { lang: "en", name: "Ссылка на презентацию" },
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'imageArray',
                name: 'projectFilesIds',
                required: true,
                label: [
                    {lang: "ru", name: "Фото"},
                    {lang: "en", name: "Фото"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
                onlyJpgFormat:true,
            },
            {
                type: 'dropdown',
                name: 'sources',
                freeTypeIndex: 3,
                label: [
                    {lang: "ru", name: "Откуда Вы узнали о «Зеленой премии»?"},
                    {lang: "en", name: "Откуда Вы узнали о «Зеленой премии»?"},
                ],
                placeholder: [
                    {lang: "ru", name: "Выберите значение"},
                    {lang: "en", name: "Выберите значение"},
                ],
                options: [{
                        label: [
                            {lang: "ru", name: "СМИ"},
                            {lang: "en", name: "СМИ"},
                        ],
                        value: 'СМИ',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Интернет"},
                            {lang: "en", name: "Интернет"},
                        ],
                        value: 'Интернет',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Друзья"},
                            {lang: "en", name: "Друзья"},
                        ],
                        value: 'Друзья',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Другое"},
                            {lang: "en", name: "Другое"},
                        ],
                        value: 'Другое',
                    }
                ],
                min: 2,
            },
            {
                type: 'cover',
                name: 'titleImage',
                required: true,
                label: [
                    {lang: "ru", name: "Обложка проекта"},
                    {lang: "en", name: "Обложка проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
            },
            // {
            //     type: 'agreement',
            //     name: 'agreement',
            //     required: true,
            //     label: [
            //         {lang: "ru", name: "Соглашение"},
            //         {lang: "en", name: "Agreement"},
            //     ],
            // },
        ]
    },
    //___________________________________________________________________________
    '8b120248cd494750814b42b361f0acd9': {
        title: [
            {lang: "ru", name: "Форма заявки"},
            {lang: "en", name: "Форма заявки"},
        ],
        fields: [
            {
                type: 'text',
                name: 'team',
                required: true,
                label: [
                    {lang: "ru", name: "Организация "},
                    {lang: "en", name: "Организация "},
                ],
                placeholder: [
                    {lang: "ru", name: "Полное наименование организации"},
                    {lang: "en", name: "Полное наименование организации"},
                ]
            },
            {
                type: 'text',
                name: 'projectAuthor',
                required: true,
                label: [
                    {lang: "ru", name: "Автор проекта"},
                    {lang: "en", name: "Автор проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "ФИО представителя"},
                    {lang: "en", name: "ФИО представителя"},
                ],
                 hint: [
                    {lang: "ru", name: "Можно добавить соавтора проекта"},
                    {lang: "en", name: "You can add a co-author to the project"},
                ],
            },
            {
                type: 'text',
                name: 'participantPhone',
                required: true,
                label: [
                    {lang: "ru", name: "Контактный телефон"},
                    {lang: "en", name: "Контактный телефон"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите контактный номер телефона"},
                    {lang: "en", name: "Укажите контактный номер телефона"},
                ],
                hint: [
                    {lang: "ru", name: "Формат телефона: +7-777-777-77-77"},
                    {lang: "en", name: "Формат телефона: +7-777-777-77-77"},
                ],
            },
            {
                type: 'text',
                name: 'participantEmail',
                required: true,
                label: [
                    {lang: "ru", name: "E-mail"},
                    {lang: "en", name: "E-mail"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите E-mail"},
                    {lang: "en", name: "Укажите E-mail"},
                ]
            },
            {
                type: 'text',
                name: 'projectTitle',
                required: true,
                max: 75,
                label: [
                    {lang: "ru", name: "Название проекта"},
                    {lang: "en", name: "Название проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите название проекта"},
                    {lang: "en", name: "Укажите название проекта"},
                ],
                hint: [
                    {lang: "ru", name: "Максимум 75 символов включая пробелы"},
                    {lang: "en", name: "Максимум 75 символов включая пробелы"},
                ],
            },
            {
                type: 'text',
                name: 'geography',
                required: true,
                label: [
                    {lang: "ru", name: "География"},
                    {lang: "en", name: "География"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите где присутствует или реализован проект"},
                    {lang: "en", name: "Укажите где присутствует или реализован проект"},
                ]
            },
            {
                type: 'text',
                name: 'partners',
                label: [
                    {lang: "ru", name: "Партнеры проекта"},
                    {lang: "en", name: "Партнеры проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите партнеров Вашего проекта, если они есть"},
                    {lang: "en", name: "Укажите партнеров Вашего проекта, если они есть"},
                ]
            },
            {
                type: 'text',
                name: 'description',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Описание"},
                    {lang: "en", name: "Описание"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите Ваш проект"},
                    {lang: "en", name: "Опишите Ваш проект"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'plans',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Планы проекта"},
                    {lang: "en", name: "Планы проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите планы на Ваш проект"},
                    {lang: "en", name: "Укажите планы на Ваш проект"},
                ],
                max: 300,
            },
            {
                type: 'text',
                name: 'result',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Результат"},
                    {lang: "en", name: "Результат"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите результат Вашего проекта"},
                    {lang: "en", name: "Опишите результат Вашего проекта"},
                ],
                max: 800,
            },
            {
                type: 'text',
                name: 'links',
                required: true,
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылка на соц. сети, сайт"},
                    {lang: "en", name: "Ссылка на соц. сети, сайт"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'mediaLinks',
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылки на СМИ о проекте"},
                    {lang: "en", name: "Ссылки на СМИ о проекте"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'demoLink',
                label: [
                    {lang: "ru", name: "Ссылка на презентацию"},
                    {lang: "en", name: "Ссылка на презентацию"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'imageArray',
                name: 'projectFilesIds',
                required: true,
                label: [
                    {lang: "ru", name: "Фото"},
                    {lang: "en", name: "Фото"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
                onlyJpgFormat:true
            },
            {
                type: 'dropdown',
                name: 'sources',
                freeTypeIndex: 3,
                label: [
                    {lang: "ru", name: "Откуда Вы узнали о «Зеленой премии»?"},
                    {lang: "en", name: "Откуда Вы узнали о «Зеленой премии»?"},
                ],
                placeholder: [
                    {lang: "ru", name: "Выберите значение"},
                    {lang: "en", name: "Выберите значение"},
                ],
                options: [{
                        label: [
                            {lang: "ru", name: "СМИ"},
                            {lang: "en", name: "СМИ"},
                        ],
                        value: 'СМИ',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Интернет"},
                            {lang: "en", name: "Интернет"},
                        ],
                        value: 'Интернет',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Друзья"},
                            {lang: "en", name: "Друзья"},
                        ],
                        value: 'Друзья',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Другое"},
                            {lang: "en", name: "Другое"},
                        ],
                        value: 'Другое',
                    }
                ],
                min: 2,
            },
            {
                type: 'cover',
                name: 'titleImage',
                required: true,
                label: [
                    {lang: "ru", name: "Обложка проекта"},
                    {lang: "en", name: "Обложка проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
            },
            // {
            //     type: 'agreement',
            //     name: 'agreement',
            //     required: true,
            //     label: [
            //         {lang: "ru", name: "Соглашение"},
            //         {lang: "en", name: "Agreement"},
            //     ],
            // },
        ]
    },
    //___________________________________________________________________________
    '348fda0aace24dc28cd5c5ffe77cf230': {
        title: [
            {lang: "ru", name: "Форма заявки"},
            {lang: "en", name: "Форма заявки"},
        ],
        fields: [
            {
                type: 'text',
                name: 'projectAuthor',
                required: true,
                label: [
                    {lang: "ru", name: "Автор проекта"},
                    {lang: "en", name: "Автор проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "ФИО"},
                    {lang: "en", name: "ФИО"},
                ],
                 hint: [
                    {lang: "ru", name: "Можно добавить соавтора проекта"},
                    {lang: "en", name: "You can add a co-author to the project"},
                ],
            },
            {
                type: 'text',
                name: 'participantPhone',
                required: true,
                label: [
                    {lang: "ru", name: "Контактный телефон"},
                    {lang: "en", name: "Контактный телефон"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите контактный номер телефона"},
                    {lang: "en", name: "Укажите контактный номер телефона"},
                ],
                hint: [
                    {lang: "ru", name: "Формат телефона: +7-777-777-77-77"},
                    {lang: "en", name: "Формат телефона: +7-777-777-77-77"},
                ],
            },
            {
                type: 'text',
                name: 'participantEmail',
                required: true,
                label: [
                    {lang: "ru", name: "E-mail"},
                    {lang: "en", name: "E-mail"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите E-mail"},
                    {lang: "en", name: "Укажите E-mail"},
                ]
            },
            {
                type: 'date',
                name: 'birthDate',
                required: true,
                label: [
                    {lang: "ru", name: "Дата рождения"},
                    {lang: "en", name: "Дата рождения"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите Вашу дату рождения"},
                    {lang: "en", name: "Укажите Вашу дату рождения"},
                ]
            },
            {
                type: 'text',
                name: 'work',
                required: true,
                label: [
                    {lang: "ru", name: "Место работы и должность"},
                    {lang: "en", name: "Место работы и должность"},
                ],
                placeholder: [
                    {lang: "ru", name: "Полное наименование организации"},
                    {lang: "en", name: "Полное наименование организации"},
                ]
            },
            {
                type: 'text',
                name: 'geography',
                required: true,
                label: [
                    {lang: "ru", name: "География"},
                    {lang: "en", name: "География"},
                ],
                placeholder: [
                    {lang: "ru", name: "Основной регион вашей деятельности"},
                    {lang: "en", name: "Основной регион вашей деятельности"},
                ]
            },
            {
                type: 'text',
                name: 'reach',
                required: true,
                label: [
                    {lang: "ru", name: "Охват"},
                    {lang: "en", name: "Охват"},
                ],
                placeholder: [
                    {lang: "ru", name: "Какое количество людей вы охватываете"},
                    {lang: "en", name: "Какое количество людей вы охватываете"},
                ]
            },
            {
                type: 'text',
                name: 'description',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Краткое описание Вашей деятельности"},
                    {lang: "en", name: "Краткое описание Вашей деятельности"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите Ваш проект"},
                    {lang: "en", name: "Опишите Ваш проект"},
                ],
                max: 200,
            },
            {
                type: 'text',
                name: 'description_2',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Подробное описание Вашей деятельности"},
                    {lang: "en", name: "Подробное описание Вашей деятельности"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите Вашу деятельность с подробным перечислением наиболее знаковых проектов"},
                    {lang: "en", name: "Опишите Вашу деятельность с подробным перечислением наиболее знаковых проектов"},
                ],
                max: 700,
            },
            {
                type: 'text',
                name: 'plans',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Ваши планы в экологической деятельности на 2025 год"},
                    {lang: "en", name: "Ваши планы в экологической деятельности на 2025 год"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите Ваши планы на общественную экологическую деятельность, какие проекты/ мероприятия/ акции планируете реализовать/ разработать"},
                    {lang: "en", name: "Опишите Ваши планы на общественную экологическую деятельность, какие проекты/ мероприятия/ акции планируете реализовать/ разработать"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'result',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Достижения"},
                    {lang: "en", name: "Достижения"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите Ваши достижения (награды, благодарственные письма, участие в конкурсах)"},
                    {lang: "en", name: "Укажите Ваши достижения (награды, благодарственные письма, участие в конкурсах)"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'links',
                required: true,
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылка на соц. сети, сайт"},
                    {lang: "en", name: "Ссылка на соц. сети, сайт"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'mediaLinks',
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылки на СМИ о проекте"},
                    {lang: "en", name: "Ссылки на СМИ о проекте"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'demoLink',
                label: [
                    {lang: "ru", name: "Ссылка на презентацию"},
                    {lang: "en", name: "Ссылка на презентацию"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'imageArray',
                name: 'projectFilesIds',
                required: true,
                label: [
                    {lang: "ru", name: "Фото"},
                    {lang: "en", name: "Фото"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
                onlyJpgFormat:true
            },
            {
                type: 'dropdown',
                name: 'sources',
                freeTypeIndex: 3,
                label: [
                    {lang: "ru", name: "Откуда Вы узнали о «Зеленой премии»?"},
                    {lang: "en", name: "Откуда Вы узнали о «Зеленой премии»?"},
                ],
                placeholder: [
                    {lang: "ru", name: "Выберите значение"},
                    {lang: "en", name: "Выберите значение"},
                ],
                options: [{
                        label: [
                            {lang: "ru", name: "СМИ"},
                            {lang: "en", name: "СМИ"},
                        ],
                        value: 'СМИ',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Интернет"},
                            {lang: "en", name: "Интернет"},
                        ],
                        value: 'Интернет',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Друзья"},
                            {lang: "en", name: "Друзья"},
                        ],
                        value: 'Друзья',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Другое"},
                            {lang: "en", name: "Другое"},
                        ],
                        value: 'Другое',
                    }
                ],
                min: 2,
            },
            {
                type: 'cover',
                name: 'titleImage',
                required: true,
                label: [
                    {lang: "ru", name: "Обложка проекта"},
                    {lang: "en", name: "Обложка проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
            },
            // {
            //     type: 'agreement',
            //     name: 'agreement',
            //     required: true,
            //     label: [
            //         {lang: "ru", name: "Соглашение"},
            //         {lang: "en", name: "Agreement"},
            //     ],
            // },
        ]
    },
    //___________________________________________________________________________
    '9b6eb324b573410bbde5b570046433b2': {
        title: [
            {lang: "ru", name: "Форма заявки"},
            {lang: "en", name: "Форма заявки"},
        ],
        fields: [
            {
                type: 'text',
                name: 'team',
                required: true,
                label: [
                    {lang: "ru", name: "Организация"},
                    {lang: "en", name: "Организация"},
                ],
                placeholder: [
                    {lang: "ru", name: "Полное наименование организации "},
                    {lang: "en", name: "Полное наименование организации "},
                ]
            },
            {
                type: 'text',
                name: 'managers',
                required: true,
                label: [
                    {lang: "ru", name: "Руководители экоцентра"},
                    {lang: "en", name: "Руководители экоцентра"},
                ],
                placeholder: [
                    {lang: "ru", name: "ФИО представителя"},
                    {lang: "en", name: "ФИО представителя"},
                ]
            },
            {
                type: 'text',
                name: 'participantPhone',
                required: true,
                label: [
                    {lang: "ru", name: "Контактный телефон"},
                    {lang: "en", name: "Контактный телефон"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите контактный номер телефона"},
                    {lang: "en", name: "Укажите контактный номер телефона"},
                ],
                hint: [
                    {lang: "ru", name: "Формат телефона: +7-777-777-77-77"},
                    {lang: "en", name: "Формат телефона: +7-777-777-77-77"},
                ],
            },
            {
                type: 'text',
                name: 'participantEmail',
                required: true,
                label: [
                    {lang: "ru", name: "E-mail"},
                    {lang: "en", name: "E-mail"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите E-mail"},
                    {lang: "en", name: "Укажите E-mail"},
                ]
            },
            {
                type: 'text',
                name: 'projectTitle',
                required: true,
                max: 75,
                label: [
                    {lang: "ru", name: "Название экоцентра"},
                    {lang: "en", name: "Название экоцентра"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите название экоцентра/ сети экоцентров"},
                    {lang: "en", name: "Укажите название экоцентра/ сети экоцентров"},
                ],
                hint: [
                    {lang: "ru", name: "Максимум 75 символов включая пробелы"},
                    {lang: "en", name: "Максимум 75 символов включая пробелы"},
                ],
            },
            {
                type: 'text',
                name: 'geography',
                required: true,
                label: [
                    {lang: "ru", name: "География"},
                    {lang: "en", name: "География"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите где находится Ваш экоцентр"},
                    {lang: "en", name: "Укажите где находится Ваш экоцентр"},
                ]
            },
            {
                type: 'text',
                name: 'reach',
                required: true,
                label: [
                    {lang: "ru", name: "Охват"},
                    {lang: "en", name: "Охват"},
                ],
                placeholder: [
                    {lang: "ru", name: "Какое количество людей было затронуто экоцентром"},
                    {lang: "en", name: "Какое количество людей было затронуто экоцентром"},
                ]
            },
            {
                type: 'text',
                name: 'partners',
                label: [
                    {lang: "ru", name: "Партнеры проекта"},
                    {lang: "en", name: "Партнеры проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите партнеров Вашего проекта, если они есть"},
                    {lang: "en", name: "Укажите партнеров Вашего проекта, если они есть"},
                ]
            },
            {
                type: 'text',
                name: 'description',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Краткое описание экоцентра"},
                    {lang: "en", name: "Краткое описание экоцентра"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите Ваш экоцентр"},
                    {lang: "en", name: "Опишите Ваш экоцентр"},
                ],
                max: 200,
            },
            {
                type: 'text',
                name: 'description_2',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Подробное описание экоцентра"},
                    {lang: "en", name: "Подробное описание экоцентра"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите Ваш экоцентр, какие наиболее знаковые мероприятия вы провели в нем, какие проекты реализовали"},
                    {lang: "en", name: "Опишите Ваш экоцентр, какие наиболее знаковые мероприятия вы провели в нем, какие проекты реализовали"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'description_3',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Описание локаций экоцентра"},
                    {lang: "en", name: "Описание локаций экоцентра"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите из каких локаций состоит экологический центр (точка приема вторичного сырья, лекционная зона, просветительские экспозиции)"},
                    {lang: "en", name: "Опишите из каких локаций состоит экологический центр (точка приема вторичного сырья, лекционная зона, просветительские экспозиции)"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'plans',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Планы экоцентра на 2025 год"},
                    {lang: "en", name: "Планы экоцентра на 2025 год"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите планы на развитие экологического центра в 2025 году"},
                    {lang: "en", name: "Укажите планы на развитие экологического центра в 2025 году"},
                ],
                max: 400,
            },
            {
                type: 'text',
                name: 'result',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Результат"},
                    {lang: "en", name: "Результат"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите результат Вашего проекта, включая количество принятого от населения вторичного сырья"},
                    {lang: "en", name: "Опишите результат Вашего проекта, включая количество принятого от населения вторичного сырья"},
                ],
                hint: [
                    {lang: "ru", name: "(количественные, качественные показатели)"},
                    {lang: "en", name: "(количественные, качественные показатели)"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'count',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Количество видов вторсырья, принимаемого от населения в центре"},
                    {lang: "en", name: "Количество видов вторсырья, принимаемого от населения в центре "},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите количество видов вторичного сырья, перечислите их"},
                    {lang: "en", name: "Опишите количество видов вторичного сырья, перечислите их"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'links',
                required: true,
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылка на соц. сети, сайт"},
                    {lang: "en", name: "Ссылка на соц. сети, сайт"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'mediaLinks',
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылки на СМИ о проекте"},
                    {lang: "en", name: "Ссылки на СМИ о проекте"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'demoLink',
                label: [
                    {lang: "ru", name: "Ссылка на презентацию"},
                    {lang: "en", name: "Ссылка на презентацию"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'imageArray',
                name: 'projectFilesIds',
                required: true,
                label: [
                    {lang: "ru", name: "Фото"},
                    {lang: "en", name: "Фото"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
                onlyJpgFormat:true
            },
            {
                type: 'dropdown',
                name: 'sources',
                freeTypeIndex: 3,
                label: [
                    {lang: "ru", name: "Откуда Вы узнали о «Зеленой премии»?"},
                    {lang: "en", name: "Откуда Вы узнали о «Зеленой премии»?"},
                ],
                placeholder: [
                    {lang: "ru", name: "Выберите значение"},
                    {lang: "en", name: "Выберите значение"},
                ],
                options: [{
                        label: [
                            {lang: "ru", name: "СМИ"},
                            {lang: "en", name: "СМИ"},
                        ],
                        value: 'СМИ',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Интернет"},
                            {lang: "en", name: "Интернет"},
                        ],
                        value: 'Интернет',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Друзья"},
                            {lang: "en", name: "Друзья"},
                        ],
                        value: 'Друзья',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Другое"},
                            {lang: "en", name: "Другое"},
                        ],
                        value: 'Другое',
                    }
                ],
                min: 2,
            },
            {
                type: 'cover',
                name: 'titleImage',
                required: true,
                label: [
                    {lang: "ru", name: "Обложка проекта"},
                    {lang: "en", name: "Обложка проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
            },
            // {
            //     type: 'agreement',
            //     name: 'agreement',
            //     required: true,
            //     label: [
            //         {lang: "ru", name: "Соглашение"},
            //         {lang: "en", name: "Agreement"},
            //     ],
            // },
        ]
    },
    //___________________________________________________________________________
    'f56f6fe5f716482e8230146098423d51': {
        title: [
            {lang: "ru", name: "Форма заявки"},
            {lang: "en", name: "Форма заявки"},
        ],
        fields: [
            {
                type: 'text',
                name: 'projectAuthor',
                required: true,
                label: [
                    {lang: "ru", name: "Автор проекта"},
                    {lang: "en", name: "Автор проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "ФИО"},
                    {lang: "en", name: "ФИО"},
                ],
                 hint: [
                    {lang: "ru", name: "Можно добавить соавтора проекта"},
                    {lang: "en", name: "You can add a co-author to the project"},
                ],
            },
            {
                type: 'text',
                name: 'participantPhone',
                required: true,
                label: [
                    {lang: "ru", name: "Контактный телефон"},
                    {lang: "en", name: "Контактный телефон"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите контактный номер телефона"},
                    {lang: "en", name: "Укажите контактный номер телефона"},
                ],
                hint: [
                    {lang: "ru", name: "Формат телефона: +7-777-777-77-77"},
                    {lang: "en", name: "Формат телефона: +7-777-777-77-77"},
                ],
            },
            {
                type: 'text',
                name: 'participantEmail',
                required: true,
                label: [
                    {lang: "ru", name: "E-mail"},
                    {lang: "en", name: "E-mail"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите E-mail"},
                    {lang: "en", name: "Укажите E-mail"},
                ]
            },
            {
                type: 'text',
                name: 'team',
                required: true,
                label: [
                    {lang: "ru", name: "Организация "},
                    {lang: "en", name: "Организация "},
                ],
                placeholder: [
                    {lang: "ru", name: "Полное наименование организации "},
                    {lang: "en", name: "Полное наименование организации "},
                ]
            },
            {
                type: 'text',
                name: 'projectTitle',
                required: true,
                max: 75,
                label: [
                    {lang: "ru", name: "Название проекта"},
                    {lang: "en", name: "Название проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите название проекта"},
                    {lang: "en", name: "Укажите название проекта"},
                ],
                hint: [
                    {lang: "ru", name: "Максимум 75 символов включая пробелы"},
                    {lang: "en", name: "Максимум 75 символов включая пробелы"},
                ],
            },
            {
                type: 'text',
                name: 'geography',
                required: true,
                label: [
                    {lang: "ru", name: "География"},
                    {lang: "en", name: "География"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите где присутствует или реализован проект"},
                    {lang: "en", name: "Укажите где присутствует или реализован проект"},
                ]
            },
            {
                type: 'text',
                name: 'reach',
                label: [
                    {lang: "ru", name: "Охват"},
                    {lang: "en", name: "Охват"},
                ],
                placeholder: [
                    {lang: "ru", name: "Какое количество людей было затронуто проектом"},
                    {lang: "en", name: "Какое количество людей было затронуто проектом"},
                ]
            },
            {
                type: 'text',
                name: 'partners',
                label: [
                    {lang: "ru", name: "Партнеры проекта"},
                    {lang: "en", name: "Партнеры проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите партнеров Вашего проекта, если они есть"},
                    {lang: "en", name: "Укажите партнеров Вашего проекта, если они есть"},
                ]
            },
            {
                type: 'text',
                name: 'goal',
                required: true,
                label: [
                    {lang: "ru", name: "Цель проекта"},
                    {lang: "en", name: "Цель проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите цель Вашего проекта"},
                    {lang: "en", name: "Укажите цель Вашего проекта"},
                ]
            },
            {
                type: 'text',
                name: 'description',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Описание проекта"},
                    {lang: "en", name: "Описание проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите Ваш проект"},
                    {lang: "en", name: "Опишите Ваш проект"},
                ],
                max: 700,
            },
            {
                type: 'text',
                name: 'description_2',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Количественные результаты"},
                    {lang: "en", name: "Количественные результаты"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите результат Вашего проекта"},
                    {lang: "en", name: "Опишите результат Вашего проекта"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'description_3',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Качественные результаты"},
                    {lang: "en", name: "Качественные результаты"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите результат Вашего проекта"},
                    {lang: "en", name: "Опишите результат Вашего проекта"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'plans',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Планы проекта"},
                    {lang: "en", name: "Планы проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите планы на ваш проект"},
                    {lang: "en", name: "Укажите планы на ваш проект"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'links',
                required: true,
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылка на соц. сети, сайт"},
                    {lang: "en", name: "Ссылка на соц. сети, сайт"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'mediaLinks',
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылки на СМИ о проекте"},
                    {lang: "en", name: "Ссылки на СМИ о проекте"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'demoLink',
                label: [
                    {lang: "ru", name: "Ссылка на презентацию"},
                    {lang: "en", name: "Ссылка на презентацию"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'imageArray',
                name: 'projectFilesIds',
                required: true,
                label: [
                    {lang: "ru", name: "Фото"},
                    {lang: "en", name: "Фото"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
                onlyJpgFormat:true
            },
            {
                type: 'dropdown',
                name: 'sources',
                freeTypeIndex: 3,
                label: [
                    {lang: "ru", name: "Откуда Вы узнали о «Зеленой премии»?"},
                    {lang: "en", name: "Откуда Вы узнали о «Зеленой премии»?"},
                ],
                placeholder: [
                    {lang: "ru", name: "Выберите значение"},
                    {lang: "en", name: "Выберите значение"},
                ],
                options: [{
                        label: [
                            {lang: "ru", name: "СМИ"},
                            {lang: "en", name: "СМИ"},
                        ],
                        value: 'СМИ',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Интернет"},
                            {lang: "en", name: "Интернет"},
                        ],
                        value: 'Интернет',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Друзья"},
                            {lang: "en", name: "Друзья"},
                        ],
                        value: 'Друзья',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Другое"},
                            {lang: "en", name: "Другое"},
                        ],
                        value: 'Другое',
                    }
                ],
                min: 2,
            },
            {
                type: 'cover',
                name: 'titleImage',
                required: true,
                label: [
                    {lang: "ru", name: "Обложка проекта"},
                    {lang: "en", name: "Обложка проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
            },
            // {
            //     type: 'agreement',
            //     name: 'agreement',
            //     required: true,
            //     label: [
            //         {lang: "ru", name: "Соглашение"},
            //         {lang: "en", name: "Agreement"},
            //     ],
            // },
        ]
    },
    //___________________________________________________________________________
    '31235d97ac974536b6661c829a673e10': {
        title: [
            {lang: "ru", name: "Форма заявки"},
            {lang: "en", name: "Форма заявки"},
        ],
        fields: [
            {
                type: 'text',
                name: 'team',
                required: true,
                label: [
                    {lang: "ru", name: "Организация "},
                    {lang: "en", name: "Организация "},
                ],
                placeholder: [
                    {lang: "ru", name: "Полное наименование организации "},
                    {lang: "en", name: "Полное наименование организации "},
                ]
            },
            {
                type: 'text',
                name: 'contactName',
                required: true,
                label: [
                    {lang: "ru", name: "Контактное лицо"},
                    {lang: "en", name: "Контактное лицо"},
                ],
                placeholder: [
                    {lang: "ru", name: "ФИО представителя организации"},
                    {lang: "en", name: "ФИО представителя организации"},
                ]
            },
            {
                type: 'text',
                name: 'participantPhone',
                required: true,
                label: [
                    {lang: "ru", name: "Контактный телефон"},
                    {lang: "en", name: "Контактный телефон"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите контактный номер телефона"},
                    {lang: "en", name: "Укажите контактный номер телефона"},
                ],
                hint: [
                    {lang: "ru", name: "Формат телефона: +7-777-777-77-77"},
                    {lang: "en", name: "Формат телефона: +7-777-777-77-77"},
                ],
            },
            {
                type: 'text',
                name: 'participantEmail',
                required: true,
                label: [
                    {lang: "ru", name: "E-mail"},
                    {lang: "en", name: "E-mail"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите E-mail"},
                    {lang: "en", name: "Укажите E-mail"},
                ]
            },
            {
                type: 'text',
                name: 'projectTitle',
                required: true,
                max: 75,
                label: [
                    {lang: "ru", name: "Название проекта"},
                    {lang: "en", name: "Название проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите название проекта"},
                    {lang: "en", name: "Укажите название проекта"},
                ],
                hint: [
                    {lang: "ru", name: "Максимум 75 символов включая пробелы"},
                    {lang: "en", name: "Максимум 75 символов включая пробелы"},
                ],
            },
            {
                type: 'text',
                name: 'description',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Краткое описание Вашей деятельности"},
                    {lang: "en", name: "Краткое описание Вашей деятельности"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите Ваш проект"},
                    {lang: "en", name: "Опишите Ваш проект"},
                ],
                max: 500,
            },
            {
                type: 'text',
                name: 'geography',
                required: true,
                label: [
                    {lang: "ru", name: "Инновационность"},
                    {lang: "en", name: "Инновационность"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите где присутствует или реализован проект"},
                    {lang: "en", name: "Укажите где присутствует или реализован проект"},
                ],
                max: 700
            },
            {
                type: 'text',
                name: 'goal',
                required: true,
                label: [
                    {lang: "ru", name: "Цель"},
                    {lang: "en", name: "Цель"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите цель Вашего проекта"},
                    {lang: "en", name: "Укажите цель Вашего проекта"},
                ]
            },
            {
                type: 'text',
                name: 'result',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Результат"},
                    {lang: "en", name: "Результат"},
                ],
                placeholder: [
                    {lang: "ru", name: "Опишите результат Вашего проекта"},
                    {lang: "en", name: "Опишите результат Вашего проекта"},
                ],
                max: 800,
            },
            {
                type: 'text',
                name: 'plans',
                multiline: true,
                required: true,
                label: [
                    {lang: "ru", name: "Планы проекта"},
                    {lang: "en", name: "Планы проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите планы на Ваш проект"},
                    {lang: "en", name: "Укажите планы на Ваш проект"},
                ],
                max: 300,
            },
            {
                type: 'text',
                name: 'reach',
                required: true,
                label: [
                    {lang: "ru", name: "Охват"},
                    {lang: "en", name: "Охват"},
                ],
                placeholder: [
                    {lang: "ru", name: "Какое количество людей было затронуто проектом"},
                    {lang: "en", name: "Какое количество людей было затронуто проектом"},
                ]
            },
            {
                type: 'text',
                name: 'partners',
                label: [
                    {lang: "ru", name: "Партнеры проекта"},
                    {lang: "en", name: "Партнеры проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите партнеров Вашего проекта, если они есть"},
                    {lang: "en", name: "Укажите партнеров Вашего проекта, если они есть"},
                ]
            },
            {
                type: 'text',
                name: 'links',
                required: true,
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылка на соц. сети, сайт"},
                    {lang: "en", name: "Ссылка на соц. сети, сайт"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'mediaLinks',
                multipleValues: true,
                label: [
                    {lang: "ru", name: "Ссылки на СМИ о проекте"},
                    {lang: "en", name: "Ссылки на СМИ о проекте"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'text',
                name: 'demoLink',
                label: [
                    {lang: "ru", name: "Ссылка на презентацию"},
                    {lang: "en", name: "Ссылка на презентацию"},
                ],
                placeholder: [
                    {lang: "ru", name: "Укажите ссылку, имеющую отношение к проекту"},
                    {lang: "en", name: "Укажите ссылку, имеющую отношение к проекту"},
                ]
            },
            {
                type: 'imageArray',
                name: 'projectFilesIds',
                required: true,
                label: [
                    {lang: "ru", name: "Фото"},
                    {lang: "en", name: "Фото"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
                onlyJpgFormat:true
            },
            {
                type: 'dropdown',
                name: 'sources',
                freeTypeIndex: 3,
                label: [
                    {lang: "ru", name: "Откуда Вы узнали о «Зеленой премии»?"},
                    {lang: "en", name: "Откуда Вы узнали о «Зеленой премии»?"},
                ],
                placeholder: [
                    {lang: "ru", name: "Выберите значение"},
                    {lang: "en", name: "Выберите значение"},
                ],
                options: [{
                        label: [
                            {lang: "ru", name: "СМИ"},
                            {lang: "en", name: "СМИ"},
                        ],
                        value: 'СМИ',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Интернет"},
                            {lang: "en", name: "Интернет"},
                        ],
                        value: 'Интернет',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Друзья"},
                            {lang: "en", name: "Друзья"},
                        ],
                        value: 'Друзья',
                    },
                    {
                        label: [
                            {lang: "ru", name: "Другое"},
                            {lang: "en", name: "Другое"},
                        ],
                        value: 'Другое',
                    }
                ],
                min: 2,
            },
            {
                type: 'cover',
                name: 'titleImage',
                required: true,
                label: [
                    {lang: "ru", name: "Обложка проекта"},
                    {lang: "en", name: "Обложка проекта"},
                ],
                placeholder: [
                    {lang: "ru", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                    {lang: "en", name: "Загрузите фотографию имеющую отношение к Вашему проекту"},
                ],
                min: 2,
            },
            // {
            //     type: 'agreement',
            //     name: 'agreement',
            //     required: true,
            //     label: [
            //         {lang: "ru", name: "Соглашение"},
            //         {lang: "en", name: "Agreement"},
            //     ],
            // },
        ]
    },
}

export default GREEN_AWARD_FORMS;